import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import CurrencyInput from "react-currency-input-field";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import ModalImage from "react-modal-image";
import Select from "react-select";
import { api } from "../../config";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../helpers/utils/handleValidDate";
import FeatherIcon from "feather-icons-react";
import CountUp from "react-countup";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../store/app/action";
import { resetDepartmentState, getDepartment } from "../../store/department/action";
import { resetCivilBudgetState, getCivilBudget } from "../../store/civilBudget/action";
import { resetVendorState, getVendor } from "../../store/vendor/action";
import { resetBudgetState, getBudget } from "../../store/budget/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../store/paymentMethod/action";
import { resetPaymentTermState, getPaymentTerm, addNewPaymentTerm } from "../../store/paymentTerm/action";
import { resetShipmentMethodState, getShipmentMethod, addNewShipmentMethod } from "../../store/shipmentMethod/action";
import { resetShipmentCarrierState, getShipmentCarrier, addNewShipmentCarrier } from "../../store/shipmentCarrier/action";
import { resetProductVarianState, getProductVarian } from "../../store/productVarian/action";
import { resetTransactionTaxState, getTransactionTax } from "../../store/transactionTax/action";
import { getAccAccount, resetAccAccountState } from "../../store/accAccount/action";
import { resetPurchaseState, getPurchase as onGetPurchases, addNewPurchase as onAddNewPurchase, updatePurchase as onUpdatePurchase, deletePurchase as onDeletePurchase, getPurchaseLoading, resetPurchaseCreateState } from "../../store/purchase/action";
import "react-toastify/dist/ReactToastify.css";

import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../Components/ModalInputFile";
import defaultImg from "../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../Components/Common/ExportDoc";
import { ButtonPrint, PrintDocExpense } from "./PrintDocExpense";

const Purchase = () => {
  const printRef = useRef(null);
  const [pageIdx, setPageIdx] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalSplit, setModalSplit] = useState(false);
  const [modalStock, setModalStock] = useState(false);
  const [modalBudget, setModalBudget] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [modalDetailExpense, setModalDetailExpense] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [submitType, setSubmitType] = useState("");

  const dispatch = useDispatch();
  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    clients,
    clientLoading,
    purchases,
    purchaseAdded,
    isPurchaseCreated,
    isPurchaseSuccess,
    loading,
    error,
    paymentMethods,
    paymentMethodLoading,
    paymentTerms,
    paymentTermLoading,
    companies,
    companyLoading,
    departments,
    departmentLoading,
    civilBudgets,
    civilBudgetLoading,
    budgets,
    budgetLoading,
    vendors,
    vendorLoading,
    shipmentMethods,
    shipmentMethodLoading,
    shipmentCarriers,
    shipmentCarrierLoading,
    branches,
    branchLoading,
    transactionTaxs,
    transactionTaxLoading,
    productVarians,
    productVarianLoading,
    accAccounts,
    accAccountLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    purchaseAdded: state.Purchase.purchaseAdded,
    purchases: state.Purchase.purchases,
    isPurchaseCreated: state.Purchase.isPurchaseCreated,
    isPurchaseSuccess: state.Purchase.isPurchaseSuccess,
    loading: state.Purchase.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    paymentTerms: state.PaymentTerm.paymentTerms,
    paymentTermLoading: state.PaymentTerm.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    vendors: state.Vendor.vendors,
    vendorLoading: state.Vendor.loading,
    shipmentCarriers: state.ShipmentCarrier.shipmentCarriers,
    shipmentCarrierLoading: state.ShipmentCarrier.loading,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    transactionTaxLoading: state.TransactionTax.loading,
    productVarians: state.ProductVarian.productVarians,
    productVarianLoading: state.ProductVarian.loading,
    error: state.Purchase.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [purchaseList, setPurchaseList] = useState([]);
  const [purchaseDoc, setPurchaseDoc] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusPurchase, setStatusPurchase] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [civilBudgetTypeList, setCivilBudgetTypeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [paymentTermList, setPaymentTermList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [shipmentMethodList, setShipmentMethodList] = useState([]);
  const [shipmentCarrierList, setShipmentCarrierList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [blockList, setBlockList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [searchBudget, setSearchBudget] = useState({});
  const [searchVendor, setSearchVendor] = useState({});

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [purDocImg, setPurDocImg] = useState([]);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const [departmentSelect, setDepartmentSelect] = useState(null);

  useEffect(() => {
    if (branchSelected && companySelected) {
      setDepartmentSelect({
        label: userData?.user?.user_department?.name,
        value: userData?.user?.user_department?.id,
      });
      setBranchIdSelected(branchSelected?.value);
      handleGetPurchase(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const toggleTab = (tab, type) => {
    let filteredPurchases = purchases;
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      if (type !== "all") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === type);
      }
      if (type === "CONFIRMED") {
        filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === "CONFIRMED" || purchase.purchase_status.name === "PROCESSED");
      }
    }
    setPurchaseList(filteredPurchases);
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "transactionat",
        label: "Tanggal Pembelian",
        isSelected: true,
        data: [],
      },
      {
        id: "dueat",
        label: "Jatuh Tempo",
        isSelected: true,
        data: [],
      },
      {
        id: "supplier",
        label: "Supplier",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_no",
        label: "No Sistem",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_reff",
        label: "No Invoice",
        isSelected: true,
        data: [],
      },
      {
        id: "budget",
        label: "Anggaran",
        isSelected: true,
        data: [],
      },
      {
        id: "material",
        label: "Material",
        isSelected: true,
        data: [],
      },
      {
        id: "volume",
        label: "Volume",
        isSelected: true,
        data: [],
      },
      {
        id: "accepted",
        label: "Volume Terima",
        isSelected: true,
        data: [],
      },
      {
        id: "price",
        label: "Harga",
        isSelected: true,
        data: [],
      },
      {
        id: "total",
        label: "Sub Total",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Total",
        isSelected: true,
        data: [],
      },
      {
        id: "down_payment",
        label: "Uang Muka",
        isSelected: true,
        data: [],
      },
      {
        id: "paid_amount",
        label: "Total Terbayar",
        isSelected: true,
        data: [],
      },
      {
        id: "purchase_status",
        label: "Status",
        isSelected: true,
        data: [],
      },
    ];

    if (purchaseList.length > 0) {
      purchaseList.forEach((purchase) => {
        if (purchase.isChecked) {
          let first = true;
          let doc = dataDoc.find((d) => d.id === "supplier");
          if (doc) doc.data.push(purchase?.purchase_vendor?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          if (doc) doc.data.push(purchase.transaction_no);

          doc = dataDoc.find((d) => d.id === "transaction_reff");
          if (doc) doc.data.push(purchase.transaction_reff);

          doc = dataDoc.find((d) => d.id === "budget");
          if (doc) doc.data.push(purchase?.purchase_cvl?.name);

          doc = dataDoc.find((d) => d.id === "transactionat");
          if (doc) doc.data.push(handleValidDate(purchase.transactionat));

          doc = dataDoc.find((d) => d.id === "dueat");
          if (doc) doc.data.push(handleValidDate(purchase.dueat));

          doc = dataDoc.find((d) => d.id === "total_amount");
          if (doc) doc.data.push(parseFloat(purchase.total_amount));

          doc = dataDoc.find((d) => d.id === "down_payment");
          if (doc) doc.data.push(parseFloat(purchase.down_payment));

          doc = dataDoc.find((d) => d.id === "paid_amount");
          if (doc) doc.data.push(parseFloat(purchase.paid_amount || 0));

          doc = dataDoc.find((d) => d.id === "purchase_status");
          if (doc) doc.data.push(purchase.hasPaid ? "PAID" : "UNPAID");

          purchase.purchase_detail.forEach((item, idx) => {
            if (!first) {
              doc = dataDoc.find((d) => d.id === "supplier");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transaction_no");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transaction_reff");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "budget");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "transactionat");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "dueat");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "total_amount");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "down_payment");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "paid_amount");
              if (doc) doc.data.push("");

              doc = dataDoc.find((d) => d.id === "purchase_status");
              if (doc) doc.data.push("");
            }
            first = false;

            doc = dataDoc.find((d) => d.id === "material");
            if (doc) doc.data.push(item.name);

            doc = dataDoc.find((d) => d.id === "volume");
            if (doc) doc.data.push(parseFloat(item.quantity));

            doc = dataDoc.find((d) => d.id === "accepted");
            if (doc) doc.data.push(parseFloat(item.accepted));

            doc = dataDoc.find((d) => d.id === "price");
            if (doc) doc.data.push(parseFloat(item.amount));

            doc = dataDoc.find((d) => d.id === "total");
            if (doc) doc.data.push(parseFloat(item.amount * item.quantity));
          });
        }
      });
    }
    setPurchaseDoc(dataDoc);
  }, [purchaseList]);

  const handleGetPurchase = (id, branchId) => {
    dispatch(resetPurchaseState());
    dispatch(onGetPurchases({ companyId: id, typeId: 1, branchId: branchId }));
    setBranchIdSelected(branchId);

    handleGetBudget(id, branchId);
    handleGetCivilBudget(id, branchId);
    handleGetVendor(id);
    handleGetDepartement(id);
    handleGetProductVariant(id);
    handleGetPaymentTerm(id);
    handleGetPaymentMethod(id, branchId);
    handleGetTransactionTax(id);
    handleGetShipmentCarrier(id);
    handleGetShipmentMethod(id);
    handleGetAccAccount(id);
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetPaymentTerm = (id) => {
    dispatch(resetPaymentTermState());
    dispatch(getPaymentTerm({ companyId: id, status: 2, type: "Purchase" }));
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2, type: "Purchase" }));
  };

  const handleGetShipmentCarrier = (companyId) => {
    dispatch(resetShipmentCarrierState());
    dispatch(getShipmentCarrier({ companyId: companyId, status: 2, type: "Purchase" }));
  };

  const handleGetShipmentMethod = (companyId) => {
    dispatch(resetShipmentMethodState());
    dispatch(getShipmentMethod({ companyId: companyId, status: 2, type: "Purchase" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, status: 2, type: "referral" }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetVendor = (companyId) => {
    //{ companyId: companyId }
    dispatch(resetVendorState());
    dispatch(getVendor());
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    setPurchase(purchaseAdded);
  }, [purchaseAdded]);

  useEffect(() => {
    if (!isEmpty(purchaseAdded)) {
      setPurchase(purchaseAdded);
    }
  }, [purchaseAdded]);

  useEffect(() => {
    let filteredPurchases = purchases;

    if (activeTypeTab !== "all") {
      filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === activeTypeTab);
    }
    if (activeTypeTab === "CONFIRMED") {
      filteredPurchases = purchases.filter((purchase) => purchase.purchase_status.name === "CONFIRMED" || purchase.purchase_status.name === "PROCESSED");
    }
    if (searchVendor?.value) {
      filteredPurchases = purchases.filter((purchase) => purchase.vendorId === searchVendor?.value);
    }

    if (searchBudget?.value) {
      let arr = [];
      filteredPurchases.forEach((f) => {
        if (searchBudget?.value && f.purchase_detail?.filter((dtl) => dtl?.civilBudgetId === searchBudget?.value).length > 0) arr.push(f);
      });
      setPurchaseList(arr);
    }
    else {
      setPurchaseList(filteredPurchases.map((el) => ({ ...el, isChecked: false })));
    }

    if (!isEmpty(filteredPurchases)) {
      setInfo(filteredPurchases[purchases.length - 1]);
    }
  }, [purchases, searchBudget, searchVendor]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var materialVarianData = [];
      var blockData = [];
      var opt = [{ label: "Select All", value: "all" }];
      var block = [{ label: "Select All", value: "all" }];
      var opt_material = [];
      productVarians.forEach((item, key) => {
        const product = item.pvar_product ? item.pvar_product : "";
        const category = product.product_category ? product.product_category.name : "";
        const blck = product.product_block ? product.product_block.id : "";
        const blck_name = product.product_block ? product.product_block.name : "";
        const name = blck_name + "-" + product.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const price = item.price;
        const brandId = item.brandId;
        const productId = item.productId;
        const priceBook = parseFloat(product.price_book);
        const land_excess = item.land_excess;
        const land_price = item.land_price;
        const price_handling = item.price_handling;
        const uom = product.product_uom ? product.product_uom.name : "";
        const branch = product.branchId;
        if (item.typeId === 1) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId, priceBook: priceBook, land_excess: land_excess, land_price: land_price, price_handling: price_handling });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });
          }
        }
        if (item.typeId === 2) {
          opt_material.push({ label: product.name, name: product.name, uom: uom, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId });
        }
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      productVarianData.push(option);
      setProductList(productVarianData);

      var option_material = { options: opt_material.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      materialVarianData.push(option_material);
      setMaterialList(materialVarianData);

      var option_block = { options: block.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      blockData.push(option_block);
      setBlockList(blockData);
    }
  }, [productVarians, branchIdSelected]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => { }, []);
  const handleBeforePrint = useCallback(() => { }, []);
  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(paymentTerms)) {
      var data = [];
      var opt = [];
      paymentTerms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, amount: item.amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentTermList(data);
    }
  }, [paymentTerms]);

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      var data = [];
      var opt = [{ label: "Non Pajak", value: 0, amount: 0 }];
      transactionTaxs.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const amount = parseFloat(item.amount) || 0;
        var obj = { label: name, value: id, amount: amount };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTaxList(data);
    }
  }, [transactionTaxs]);

  useEffect(() => {
    if (!isEmpty(shipmentCarriers)) {
      var data = [];
      var opt = [];
      shipmentCarriers.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentCarrierList(data);
    }
  }, [shipmentCarriers]);

  useEffect(() => {
    if (!isEmpty(shipmentMethods)) {
      var data = [];
      var opt = [];
      shipmentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setShipmentMethodList(data);
    }
  }, [shipmentMethods]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "NON CASHFLOW", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name + ", " + item?.budget_branch?.branch_code;
        const id = item.id;
        var obj = { label: name, value: id };
        if (item.type === "CASH OUT")
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })).reverse() };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  const toggleDetailExpense = useCallback(() => {
    if (modalDetailExpense) {
      setModalDetailExpense(false);
    } else {
      setModalDetailExpense(true);
    }
  }, [modalDetailExpense]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilTypeData = [];
      var opt = [];
      var optType = [];
      civilBudgets
        .filter((f) => f.type === "BANGUNAN" || f.type === "INFRASTRUKTUR" || f.type === "PEKERJAAN TAMBAH 1" || f.type === "PEKERJAAN TAMBAH 2" || f.type === "PEKERJAAN TAMBAH 3" || f.type === "PEKERJAAN TAMBAH 4" || f.type === "PEKERJAAN TAMBAH 5" || f.type === "PEKERJAAN TAMBAH 6" || f.type === "PEKERJAAN TAMBAH 7" || f.type === "PEKERJAAN TAMBAH 8")
        .forEach((it, idx) => {
          const type = it.type ? it.type : "";
          const typeName = it.name ? it.name : "";
          if (branchIdSelected === it.branchId) {
            const budgetId = it.id ? it.id : "";
            it.cvl_detail.forEach((item, key) => {
              const name = item?.cvld_account?.name;
              const id = item?.cvld_account?.id;
              opt.push({ label: type + " - " + name, cvl_account: name, value: budgetId, type: type, civilBudgetId: budgetId, civilBudgetDetailId: item.id, civilAccountId: id, material: item.cvld_material });
            });
          }
          optType.push({ label: typeName, value: it.id });
        });
      var option = { options: opt };
      var option_type = { options: optType };
      civilBudgetData.push(option);
      civilTypeData.push(option_type);
      setCivilBudgetList(civilBudgetData);
      setCivilBudgetTypeList(civilTypeData);
    }
    else {
      setCivilBudgetList([]);
      setCivilBudgetTypeList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(vendors)) {
      var vendorData = [];
      var opt = [];
      vendors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      vendorData.push(option);
      setVendorList(vendorData);
    }
  }, [vendors]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const handleDeletePurchase = () => {
    if (purchase) {
      dispatch(onDeletePurchase(purchase));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPurchase(null);
      setBlockList([]);
      setProductList([]);
      setPurDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleBudget = useCallback(() => {
    if (modalBudget) {
      setModalBudget(false);
      setPurchase(null);
      setBlockList([]);
      setProductList([]);
      setPurDocImg([]);
      validationBudget.resetForm();
    } else {
      setModalBudget(true);
    }
  }, [modalBudget]);

  const toggleStock = useCallback(() => {
    if (modalStock) {
      setModalStock(false);
      setPurchase(null);
      setBlockList([]);
      setProductList([]);
      setPurDocImg([]);
      validationStock.resetForm();
    } else {
      setModalStock(true);
    }
  }, [modalStock]);

  const toggleSplit = useCallback(() => {
    if (modalSplit) {
      setModalSplit(false);
      setPurchase(null);
      setBlockList([]);
      setProductList([]);
      setPurDocImg([]);
      validationSplit.resetForm();
    } else {
      setModalSplit(true);
    }
  }, [modalSplit]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleApprove = useCallback(() => {
    if (modalApprove) {
      setModalApprove(false);
    } else {
      setModalApprove(true);
    }
  }, [modalApprove]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setPurchase(null);
      setPurDocImg([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  const handlePurchaseClick = useCallback((arg, type) => {
    const data = arg;
    let purchaseDetail = [];

    let arrUnit = [];

    if (data.unit) {
      data.unit.forEach((item) => {
        var obj = { label: item.name, name: item.name, barcode: item.barcode, sku: item.sku, value: item.productId, price: item.price, brandId: item.brandId, productId: item.productId };
        arrUnit.push(obj);
      });
    }
    setBranchIdSelected(data.purchase_branch.id);
    handleGetCivilBudget(data.purchase_company.id, data.branchId);
    if (data.purchase_detail) {
      data.purchase_detail.forEach((element) => {
        purchaseDetail.push({
          detailId: element.id,
          itemId: element.productVarianId,
          account: {
            label: element.cvl_account,
            value: element.civilAccountId,
          },
          item: { label: `${element.name} - ${element.barcode}`, uom: element?.purchase_detail_product?.product_uom?.name, value: element.productVarianId, name: element.name, sku: element.sku, barcode: element.barcode, amount: element.amount, brandId: element.brandId, productId: element.productId },
          amount: parseFloat(element.amount),
          quantity: parseFloat(element.quantity),
          total: parseFloat(element.amount_total),
          name: element.name,
          uom: element?.purchase_detail_product?.product_uom?.name,
          sku: element.sku,
          barcode: element.barcode,
          disable: false, //element.civilAccountId ? true : false,
          brandId: element.brandId,
          accepted: element.accepted ? parseFloat(element.accepted) : 0,
          rejected: element.rejected ? parseFloat(element.rejected) : 0,

          cvl_account: element?.purchase_cvl_budget?.cvld_account?.name,
          type: element?.purchase_cvl_budget?.type,
          cvl_label: element?.purchase_cvl_budget?.cvld_account?.name,
          civilBudgetId: element?.civilBudgetId,
          civilBudgetDetailId: element?.civilBudgetDetailId,
          civilAccountId: element?.civilAccountId,
        });
      });
    }

    let files = [];
    for (const f of data.purchase_file) {
      files.push({ filename: f.filename, originalname: f.originalname });
    }
    setPurDocImg(files);
    setPurchase({
      id: data.id,
      statusId: data.statusId,
      transaction_no: data.transaction_no,
      transaction_reff: data.transaction_reff,
      purchase_file: data.purchase_file,
      description: data.description,
      transactionat: data.transactionat,
      dueat: data.dueat,
      type: data.type && { label: data.type, value: data.type },
      company: data.purchase_company && data.purchase_company.name && { label: data.purchase_company.name, value: data.purchase_company.id },
      tax: data.purchase_tax && {
        label: data.purchase_tax.name,
        value: data.purchase_tax.id,
        amount: parseFloat(data.purchase_tax.amount),
      },
      unit: arrUnit,
      block: data.purchase_block && {
        label: data.purchase_block.name,
        value: data.purchase_block.id,
      },
      branch: data.purchase_branch && {
        label: data.purchase_branch.name,
        value: data.purchase_branch.id,
      },
      client: data.purchase_client && {
        label: data.purchase_client.name,
        value: data.purchase_client.id,
      },
      shipmentCarrier: data.purchase_shipment_carrier && {
        label: data.purchase_shipment_carrier.name,
        value: data.purchase_shipment_carrier.id,
      },
      shipmentMethod: data.purchase_shipment_method && {
        label: data.purchase_shipment_method.name,
        value: data.purchase_shipment_method.id,
      },
      paymentMethod: data.purchase_pm && {
        label: data.purchase_pm.name,
        value: data.purchase_pm.id,
      },
      paymentTerm: data.purchase_payment_term && {
        label: data.purchase_payment_term.name,
        value: data.purchase_payment_term.id,
      },
      department: data.purchase_department && {
        label: data.purchase_department.name,
        value: data.purchase_department.id,
      },
      vendor: data.purchase_vendor && {
        label: data?.purchase_vendor?.name,
        value: data?.purchase_vendor?.id,
        contact: data?.purchase_vendor?.vendor_contact[0]?.name,
      },
      purchase_history: data.purchase_history,
      purchase_approvedby: data.purchase_approvedby && {
        label: data.purchase_approvedby.name,
        value: data.purchase_approvedby.id,
      },
      purchase_createdby: data.purchase_createdby && {
        label: data.purchase_createdby.name,
        value: data.purchase_createdby.id,
      },
      budget: data.purchase_budget && { label: data.purchase_budget.name, value: data.purchase_budget.id },
      status: data.purchase_status && { label: data.purchase_status.name, value: data.purchase_status.id },
      total_amount: data.total_amount ? parseFloat(data.total_amount) : 0,
      sub_amount: data.sub_amount ? parseFloat(data.sub_amount) : 0,
      tax_percentage: data.tax_percentage ? parseFloat(data.tax_percentage) : 0,
      tax_amount: data.tax_amount ? parseFloat(data.tax_amount) : 0,
      down_payment: data.down_payment ? parseFloat(data.down_payment) : 0,
      shipment_amount: data.shipment_amount ? parseFloat(data.shipment_amount) : 0,
      disc_amount: data.disc_amount ? parseFloat(data.disc_amount) : 0,
      items: purchaseDetail,
      items_split: [{ transaction_reff: "", data: purchaseDetail }],
    });

    setIsEdit(true);
    switch (type) {
      case "detail":
        toggleDetail();
        break;
      case "budget":
        toggleBudget();
        break;
      case "stock":
        toggleStock();
        break;
      case "split":
        toggleSplit();
        break;
      case "detail-expense":
        toggleDetailExpense();
        break;
      default:
        setIsEdit(true);
        toggle();
        break;
    }
  },
    [toggle]
  );

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = purchaseList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setPurchaseList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      let qty = 0;
      let acc = 0;
      data.purchase_detail.forEach((element) => {
        qty += element.quantity ? parseFloat(element.quantity) : 0;
        acc += element.accepted ? parseFloat(element.accepted) : 0;
      });
      return (
        <div className="hstack gap-2">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={data.isChecked}
            onChange={() => {
              const updatedData = purchaseList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setPurchaseList(updatedData);
            }} />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  setInfo(data);
                  toggleHistory();
                }}>
                <i className=" ri-history-line fs-15"></i>
              </Button>
              {data.statusId <= 3 && (
                <Button
                  color="light"
                  className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePurchase") !== -1 ? "btn-sm" : "btn-sm d-none"}
                  onClick={() => {
                    setSubmitType("save");
                    handlePurchaseClick(data);
                  }}>
                  <i className="ri-edit-2-line fs-15"></i>
                </Button>
              )}
              {(data.statusId === 1 || userType === "admin" || userType === "client") && (
                <Button
                  color="light"
                  className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePurchase") !== -1 ? "btn-sm" : "btn-sm d-none"}
                  onClick={() => {
                    data.actionTitle = `Anda Akan Membatalkan Transaksi Pembelian Ke  ${data?.purchase_vendor?.name}  #${data.code} `;
                    data.statusPurchaseId = 6;
                    setPurchase(data);
                    toggleApprove();
                  }}>
                  <i className="ri-delete-bin-line fs-15 text-danger"></i>
                </Button>
              )}
              <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("createPurchase") !== -1 ? "btn btn-sm btn-light" : "d-none"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    handlePurchaseClick(data, "detail");
                  }}>
                  PRINT TRANSAKSI
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    toggleDetailExpense();
                  }}>
                  PRINT RO
                </DropdownItem>
                <DropdownItem divider></DropdownItem>
                <DropdownItem
                  onClick={() => {
                    handlePurchaseClick(data, "split");
                  }}>
                  SPLIT INVOICE
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    handlePurchaseClick(data, "budget");
                  }}>
                  KOREKSI UMUM
                </DropdownItem>
                {/* {data.statusId > 1 && userType === "admin" && (
                  <DropdownItem
                    onClick={() => {
                      handlePurchaseClick(data, "stock");
                    }}>
                    KOREKSI STOK
                  </DropdownItem>
                )} */}
                <DropdownItem divider></DropdownItem>
                <DropdownItem
                  onClick={() => {
                    data.actionTitle = `Anda Akan Menandai Transaksi Pembelian ke ${data?.purchase_vendor?.name} #${data.code} Sudah Selesai`;
                    data.statusPurchaseId = 5;
                    setPurchase(data);
                    toggleApprove();
                  }}>
                  COMPLETED
                </DropdownItem>
                <DropdownItem
                  className={acc === 0 ? "d-none" : ""}
                  onClick={() => {
                    data.actionTitle = `Anda Akan Meretur Transaksi Pembelian Ke ${data?.purchase_vendor?.name} #${data.code}`;
                    data.statusPurchaseId = 7;
                    setPurchase(data);
                    toggleApprove();
                  }}>
                  RETURNED
                </DropdownItem>
                <DropdownItem
                  className={userType === "admin" || (userRole && userRole.split(",").indexOf("createAccTransaction") !== -1) ? "" : "d-none"}
                  onClick={() => {
                    data.actionTitle = `Anda Akan Menambahkan Hutang Ke Transaksi Keuangan Untuk ${data?.purchase_vendor?.name}  #${data.code} `;
                    data.statusPurchaseId = 88;
                    setPurchase(data);
                    toggleApprove();
                  }}>
                  AKUI HUTANG
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
          {qty === acc && (data.statusId === 3 || data.statusId === 2 || data.code === "") && (
            <button
              className={userType === "admin" || userType === "client" ? "btn btn-sm btn-soft-info" : userRole && userRole.split(",").indexOf("approvePurchase") !== -1 ? "btn btn-sm btn-soft-info" : "btn btn-sm btn-soft-info d-none"}
              onClick={() => {
                setSubmitType("received");
                handlePurchaseClick(data);
              }}>
              <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>INVOICE
            </button>
          )}
          {/* {userType === "admin" && !data.hasPaid && qty === acc && (
            <button
              className={moment().diff(data.dueat, "days") > 0 ? "btn btn-sm bg-soft-danger" : "btn btn-sm btn-soft-success"}
              onClick={() => {
                setInfo(data);
                toggleAccPayment();
              }}>
              <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>PEMBAYARAN
            </button>
          )} */}
          {/* {(data.hasPaid || parseFloat(data.paid_amount) > 0) && (userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("processPurchase"))) && (
            <button
              className="btn btn-sm btn-soft-danger"
              onClick={() => {
                data.actionTitle = `Anda Akan Membatalkan Transaksi Pembayaran Ke ${data?.purchase_vendor?.name}  #${data.code} `;
                data.statusPurchaseId = 99;
                setPurchase(data);
                toggleApprove();
              }}>
              <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>CANCEL BAYAR
            </button>
          )} */}
        </div>
      );
    },
    id: "#",
  },
  {
    id: "Tanggal",
    Header: "Tanggal",
    accessor: "transactionat",
    filterable: true,
    Cell: (data) => {
      return (
        <div>
          <div className="mb-1">{handleValidDate(data.row.original.transactionat, "DD/MM/YYYY")}</div>
          <div className="fs-11 text-muted">{moment.utc(data.row.original.transactionat, "YYYY/MM/DD HH:mm:ss").local().fromNow()}</div>
        </div>
      );
    },
  },
  {
    Header: "No Invoice",
    accessor: "transaction_reff",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <>
          <div className="mb-0">
            <Link
              to="#"
              className="fw-semibold text-dark"
              onClick={() => {
                handlePurchaseClick(data, "detail");
              }}
            >
              {data.transaction_reff || "-"}
            </Link>
          </div>
          <div className="mb-0">
            <em className="mb-0 fs-10 text-muted">{data.purchase_createdby.name}</em>
          </div>
        </>
      );
    },
  },
  {
    Header: "No Sistem",
    accessor: "transaction_no",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <>
          <div className="mb-0">
            <Link
              to="#"
              className="fw-semibold text-dark"
              onClick={() => {
                handlePurchaseClick(data, "detail");
              }}
            >
              {data.transaction_no || "-"}
            </Link>
          </div>
          <div className="mb-0">
            <em className="mb-0 fs-10 text-muted">{data.purchase_department.name}</em>
          </div>
        </>
      );
    },
  },
  {
    id: "Proyek",
    Header: "Proyek",
    accessor: "purchase_branch.branch_code",
    filterable: true,
  },
  {
    id: "Detail",
    Header: "Detail",
    accessor: (data) => JSON.stringify(data.purchase_detail),
    filterable: true,
  },
  {
    id: "Keterangan",
    Header: "Keterangan",
    accessor: "purchase_cvl.name",
    filterable: true,
  },
  {
    id: "Description",
    Header: "Description",
    accessor: "description",
    filterable: true,
  },
  {
    Header: "Suplier",
    accessor: "purchase_vendor.name",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let vendor = data?.purchase_vendor?.name;
      let branch = data?.purchase_branch?.branch_code;
      let stat;
      let statName = data?.purchase_status?.name;
      switch (statName) {
        case "DRAFT":
          stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
          break;
        case "CONFIRMED":
          stat = <span className="badge text-uppercase badge-soft-info">CONFIRMED</span>;
          break;
        case "PROCESSED":
          stat = <span className="badge text-uppercase badge-soft-info">CONFIRMED</span>;
          break;
        case "RECEIVED":
          stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
          break;
        case "COMPLETED":
          stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
          break;
        default:
          stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
          break;
      }

      let typeLabel;
      let type = data?.purchase_detail[0]?.purchase_cvl_budget?.type;
      switch (type) {
        case "BANGUNAN":
          typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
          break;
        case "INFRASTRUKTUR":
          typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
          break;
        case "UPAH":
          typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
          break;
        default:
          typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
          break;
      }
      return (
        <>
          <div className="mb-1"><span className="fw-semibold">{branch}</span> {vendor}</div>
          <div className="hstack gap-2">
            {typeLabel}
            {stat}
            {data.hasPaid ? <span className="badge text-uppercase badge-soft-info">Paid</span> : <span className="badge text-uppercase badge-soft-warning">Unpaid</span>}
          </div>
        </>
      );
    },
  },
  {
    id: "UmurHutang",
    Header: "UmurHutang",
    accessor: (row) => {
      moment.utc(row.dueat, "YYYY/MM/DD HH:mm:ss").local().fromNow();
    },
    filterable: true,
  },
  {
    Header: "Jumlah - Terima",
    accessor: "sub_amount",
    filterable: true,
    Cell: (data) => {
      let qty = 0;
      let acc = 0;
      data.row.original.purchase_detail.forEach((element) => {
        qty += element.quantity ? parseFloat(element.quantity) : 0;
        acc += element.accepted ? parseFloat(element.accepted) : 0;
      });
      return (
        <div>
          <span className="fw-semibold">{currencyFormat(qty)}</span> <span className="text-muted"> - {currencyFormat(acc)}</span>
        </div>
      );
    },
  },
  {
    id: "Total",
    Header: <div className="text-end pe-3">Total</div>,
    accessor: "total_amount",
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-end pe-2">{currencyFormat(data.row.original.total_amount === null ? 0 : data.row.original.total_amount)}</div>;
    },
  },
  {
    id: "UangMuka",
    Header: "Uang Muka",
    accessor: "down_payment",
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-end pe-2">{currencyFormat(data.row.original.down_payment === null ? 0 : data.row.original.down_payment)}</div>;
    },
  },
  {
    id: "Terbayar",
    Header: <div className="text-end pe-3">Terbayar</div>,
    accessor: "paid_amount",
    filterable: true,
    Cell: (data) => {
      return <div className="fw-semibold text-success text-end pe-2">{currencyFormat(data.row.original.paid_amount === null ? 0 : data.row.original.paid_amount)}</div>;
    },
  },
  {
    id: "SisaBayar",
    Header: <div className="text-end pe-3">Sisa Bayar</div>,
    filterable: true,
    accessor: (row) => row.total_amount - row.paid_amount,
    Cell: (data) => {
      return <div className="fw-semibold text-danger text-end pe-2">{currencyFormat(data.row.original.total_amount - data.row.original.paid_amount)}</div>;
    },
  },
  {
    Header: "Jatuh Tempo",
    accessor: "dueat",
    filterable: true,
    Cell: (data) => {
      return (
        <div className={!data.row.original.hasPaid && moment().diff(data.row.original.dueat, "days") > 0 ? "text-danger" : ""}>
          <div className="mb-1">{handleValidDate(data.row.original.dueat, "DD/MM/YYYY")}</div>
          {!data.hasPaid && <div className="fs-11 text-muted">{moment.utc(data.row.original.dueat, "YYYY/MM/DD HH:mm:ss").local().fromNow()}</div>}
        </div>
      );
    },
  },
  // {
  //   Header: "Down Payment",
  //   accessor: "down_payment",
  //   filterable: true,
  //   Cell: (data) => {
  //     return <span>{currencyFormat(data.row.original.down_payment === null ? 0 : data.row.original.down_payment)}</span>;
  //   },
  // },
  {
    id: "Status",
    Header: "Status",
    accessor: "purchase_status.name",
    filterable: true,
  }], [purchaseList, handlePurchaseClick, toggleApprove, toggleHistory, userRole, userType, isCheckAll]);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = purchaseList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setPurchaseList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => purchaseList, [purchaseList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status", "Keterangan", "UmurHutang", "UangMuka", "Proyek", "TransactionNo", "Detail", "Description"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: (info && info.total_amount - info.paid_amount) || 0,
      account: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      account: Yup.object().required("Please enter payment account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      if (info) {
        info.setAccPayment = true;
        info.setApprove = false;
        info.accPaymentId = values.account.value;
        info.transactionat = values.transactionat;
        info.accType = "PAYABLE";
        info.description = info.code ? `PEMBAYARAN INVOICE (${info?.purchase_vendor?.name} #${info.code})` : `PEMBAYARAN INVOICE (${info?.purchase_vendor?.name})`;
        info.amount = values.amount;
        dispatch(onUpdatePurchase(info));
      }
      validationAccPayment.resetForm();
      toggleAccPayment();
    },
  });

  const validationApprove = useFormik({
    enableReinitialize: true,
    initialValues: {
      approval_note: "",
    },
    onSubmit: (values) => {
      if (purchase) {
        purchase.setApprove = true;
        purchase.approval_note = values.approval_note;
        dispatch(onUpdatePurchase(purchase));
      }
      validationApprove.resetForm();
      toggleApprove();
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      client: (purchase && purchase.client) || clientSelected,
      company: (purchase && purchase.company) || companySelected,
      budget: (purchase && purchase.budget) ?? "",
      unit: (purchase && purchase.unit) ?? "",
      transaction_reff: (purchase && purchase.transaction_reff) ?? "",
      branch: (purchase && purchase.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
      department: (purchase && purchase.department) ?? "", //departmentSelect
      shipmentCarrier: (purchase && purchase.shipmentCarrier) ?? "",
      shipmentMethod: (purchase && purchase.shipmentMethod) ?? "",
      paymentMethod: (purchase && purchase.paymentMethod) ?? "",
      paymentTerm: (purchase && purchase.paymentTerm) ?? "",
      transactionat: (purchase && purchase.transactionat) ?? "",
      dueat: (purchase && purchase.dueat) ?? "",
      description: (purchase && purchase.description) ?? "",
      vendor: (purchase && purchase.vendor) ?? "",
      disc_amount: (purchase && purchase.disc_amount) || 0,
      tax: (purchase && purchase.tax) ?? "",
      block: (purchase && purchase.block) ?? "",
      tax_percentage: (purchase && purchase.tax_percentage) || 0,
      tax_amount: (purchase && purchase.tax_amount) || 0,
      total_amount: (purchase && purchase.total_amount) || 0,
      sub_amount: (purchase && purchase.sub_amount) || 0,
      shipment_amount: (purchase && purchase.shipment_amount) || 0,
      down_payment: (purchase && purchase.down_payment) || 0,
      items: (purchase && purchase.items) || [],
    },
    validationSchema: Yup.object({
      paymentMethod: Yup.object().required("Please Select Payment Method").nullable(true),
      transactionat: Yup.string().required("Please enter transaction date"),
      branch: Yup.object().required("Please Select Warehouse").nullable(true),
      department: Yup.object().required("Please Select Department").nullable(true),
      vendor: Yup.object().required("Please Select Vendor").nullable(true),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          transaction_reff: values.transaction_reff,
          description: values.description,
          transactionat: values.transactionat,
          budgetId: values.budget.value,
          unit: values.unit,
          blockId: values.block.value,
          dueat: values.dueat,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipment_amount,
          paymentMethodId: values.paymentMethod.value,
          paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value === 0 ? null : values.tax.value,
          tax_percentage: values.tax_percentage,
          clientId: values.client.value,
          departmentId: values.department.value,
          branchId: values.branch.value,
          vendorId: values.vendor.value,
          companyId: values.company.value,
          disc_amount: values.disc_amount,
          total_amount: values.total_amount,
          tax_amount: values.tax_amount,
          sub_amount: values.sub_amount,
          down_payment: values.down_payment,
          purchase_detail: JSON.stringify(values.items),
          files: purDocImg.length > 0 ? purDocImg : [],
        };

        if (submitType === "process") {
          editSubmit.statusPurchaseId = 3;
        }

        if (submitType === "received") {
          editSubmit.statusPurchaseId = 4;
        }

        if (submitType === "save") {
          editSubmit.statusPurchaseId = 1;
        }

        dispatch(onUpdatePurchase(editSubmit));
      } else {
        let addSubmit = {
          transaction_reff: values.transaction_reff,
          description: values.description,
          transactionat: values.transactionat,
          dueat: values.dueat,
          branchId: values.branch.value,
          budgetId: values.budget.value,
          unit: values.unit,
          blockId: values.block.value,
          shipmentCarrierId: values.shipmentCarrier.value,
          shipmentMethodId: values.shipmentMethod.value,
          shipment_amount: values.shipment_amount,
          paymentMethodId: values.paymentMethod.value,
          paymentTermId: values.paymentTerm.value,
          taxId: values.tax.value === 0 ? null : values.tax.value,
          tax_percentage: values.tax_percentage,
          statusPurchaseId: 1,
          clientId: values.client.value,
          departmentId: values.department.value,
          vendorId: values.vendor.value,
          companyId: values.company.value,
          disc_amount: values.disc_amount,
          total_amount: values.total_amount,
          tax_amount: values.tax_amount,
          sub_amount: values.sub_amount,
          down_payment: values.down_payment,
          purchase_detail: JSON.stringify(values.items),
          files: purDocImg.length > 0 ? purDocImg : [],
        };
        dispatch(onAddNewPurchase(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const validationBudget = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      transaction_reff: (purchase && purchase.transaction_reff) ?? "",
      vendor: (purchase && purchase.vendor) ?? "",
      department: (purchase && purchase.department) || departmentSelect,
      dueat: (purchase && purchase.dueat) ?? "",
      transactionat: (purchase && purchase.transactionat) ?? "",
      description: (purchase && purchase.description) ?? "",
      items: (purchase && purchase.items) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      let editSubmit = {
        id: values.id,
        type: "Correction",
        vendorId: values.vendor.value,
        transactionat: values.transactionat,
        departmentId: values.department.value,
        dueat: values.dueat,
        transaction_reff: values.transaction_reff,
        description: values.description,
        purchase_detail: JSON.stringify(values.items),
        files: purDocImg.length > 0 ? purDocImg : [],
      };

      if (submitType === "process") {
        editSubmit.statusPurchaseId = 3;
      }

      if (submitType === "received") {
        editSubmit.statusPurchaseId = 4;
      }

      if (submitType === "save") {
        editSubmit.statusPurchaseId = 1;
      }

      dispatch(onUpdatePurchase(editSubmit));
      validationBudget.resetForm();
      toggleBudget();
    },
  });

  const validationStock = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      items: (purchase && purchase.items) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      let editSubmit = {
        id: values.id,
        type: "StockCorrection",
        purchase_detail: JSON.stringify(values.items),
      };

      if (submitType === "process") {
        editSubmit.statusPurchaseId = 3;
      }

      if (submitType === "received") {
        editSubmit.statusPurchaseId = 4;
      }

      if (submitType === "save") {
        editSubmit.statusPurchaseId = 1;
      }

      dispatch(onUpdatePurchase(editSubmit));
      validationStock.resetForm();
      toggleStock();
    },
  });

  const validationSplit = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (purchase && purchase.id) || 0,
      items: (purchase && purchase.items) || [],
      items_split: (purchase && purchase.items_split) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getPurchaseLoading());
      let editSubmit = {
        id: values.id,
        type: "Split",
        purchase_split: JSON.stringify(values.items_split),
        files: purDocImg.length > 0 ? purDocImg : [],
      };

      dispatch(onUpdatePurchase(editSubmit));
      validationSplit.resetForm();
      toggleSplit();
    },
  });

  const handlePurchaseDetailAdd = () => {
    validation.setFieldValue("items", [
      ...validation.values.items,
      {
        detailId: 0,
        itemId: 0,
        item: {
          label: "Pilih Material",
          value: 0,
          name: "Pilih Material",
          sku: "",
          barcode: "",
          amount: 0,
          uom: "",
          brandId: 0,
          productId: 0,
        },
        account: {
          label: "Pilih Item Anggaran",
          value: 0,
        },
        amount: 0,
        quantity: 0,
        total: 0,
        name: "",
        uom: "",
        sku: "",
        barcode: "",
        brandId: 0,
        accepted: 0,
        rejected: 0,
        type: "",
        cvl_account: "",
        cvl_label: "",
        civilBudgetId: 0,
        civilBudgetDetailId: 0,
        civilAccountId: 0,
      },
    ]);
    handleTotal();
  };

  const handlePurchaseSplitAdd = () => {
    let obj = [];
    validationSplit.values.items.forEach((a) => {
      obj.push(a);
    });
    let inv = { transaction_reff: "", data: obj };
    validationSplit.setFieldValue("items_split", [...validationSplit.values.items_split, inv]);
  };

  const handlePurchaseDetailAddByBudget = (e) => {
    let arr = [...validation.values.items];
    let sub_amount = 0;
    if (e.material && e.material.length > 0) {
      for (const material of e.material) {
        let findVarian = productVarians.find((d) => d.productId === material.productId);
        if (findVarian) {
          const varian = findVarian.pvar_product ? findVarian.pvar_product : "";
          const id = findVarian.id;
          const barcode = findVarian.barcode;
          const sku = findVarian.sku;
          const price = findVarian.price;
          const brandId = findVarian.brandId;
          const productId = findVarian.productId;

          let quantity = validation.values.unit.length ? parseFloat(material.quantity * validation.values.unit.length) : parseFloat(material.quantity * 1);
          sub_amount += Math.round(quantity * material.price);
          arr.push({
            detailId: 0,
            itemId: id,
            item: { label: varian.name, name: varian.name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId },
            account: {
              label: e.label,
              value: e.value,
            },
            amount: Math.round(material.price),
            quantity: quantity,
            total: quantity * Math.round(material.price),
            name: varian.name,
            disable: false,
            sku: sku,
            barcode: barcode,
            brandId: brandId,
            accepted: 0,
            rejected: 0,
            uom: varian?.product_uom?.name,
            type: e?.type,
            cvl_account: e?.cvl_account,
            cvl_label: e?.label,
            civilBudgetId: e?.civilBudgetId,
            civilBudgetDetailId: e?.civilBudgetDetailId,
            civilAccountId: e?.civilAccountId,
          });
        }
      }
      let sub_total_net = sub_amount - validation.values.disc_amount;
      let tax_amount = (validation.values.tax_percentage / 100) * sub_total_net;
      let total_amount = sub_total_net + tax_amount + validation.values.shipment_amount;

      validation.setFieldValue("tax_amount", parseFloat(tax_amount));
      validation.setFieldValue("total_amount", Math.round(total_amount));
      validation.setFieldValue("sub_amount", Math.round(sub_amount));
      validation.setFieldValue("items", arr);
    } else {
      validation.setFieldValue("items", [
        ...validation.values.items,
        {
          detailId: 0,
          itemId: 0,
          item: {
            label: "Pilih Material",
            value: 0,
            name: "Pilih Material",
            sku: "",
            barcode: "",
            amount: 0,
            uom: "",
            brandId: 0,
            productId: 0,
          },
          account: {
            label: "Pilih Item Anggaran",
            value: 0,
          },
          amount: 0,
          quantity: 0,
          total: 0,
          name: "",
          uom: "",
          sku: "",
          barcode: "",
          brandId: 0,
          accepted: 0,
          rejected: 0,
          type: e?.type,
          cvl_account: e?.cvl_account,
          cvl_label: e?.label,
          civilBudgetId: e?.civilBudgetId,
          civilBudgetDetailId: e?.civilBudgetDetailId,
          civilAccountId: e?.civilAccountId,
        },
      ]);
      handleTotal();
    }
  };

  const onClickDeleteDetailItem = (index) => {
    validation.values.items.splice(index, 1);
    handleTotal();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = purDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setPurDocImg(newState);
    } else {
      const index = purDocImg.findIndex((fl) => fl.filename === file.filename);
      setPurDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };
  const handleSelectFile = (file) => {
    setPurDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleTotal = () => {
    let sub_amount = 0;
    for (const item of validation.values.items) {
      sub_amount += Math.round(item.quantity * item.amount);
    }
    let sub_total_net = sub_amount - validation.values.disc_amount;
    let tax_amount = (validation.values.tax_percentage / 100) * sub_total_net;
    let total_amount = sub_total_net + tax_amount + validation.values.shipment_amount;

    validation.setFieldValue("tax_amount", Math.round(tax_amount));
    validation.setFieldValue("total_amount", Math.round(total_amount));
    validation.setFieldValue("sub_amount", Math.round(sub_amount));
  };

  const handlePriceDetail = (e, i) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.values.items[i].amount = val;
      validation.values.items[i].total = Math.round(validation.values.items[i].quantity * val);
    } else {
      validation.values.items[i].amount = 0;
      validation.values.items[i].total = Math.round(validation.values.items[i].quantity * 0);
    }
    handleTotal();
  };

  const handleBtnQtyDetail = (type, i) => {
    if (type === "add") {
      let valReduce = validation.values.items[i].quantity + 1;
      validation.values.items[i].quantity = valReduce;
      validation.values.items[i].total = Math.round(validation.values.items[i].amount * valReduce);
      handleTotal();
    } else if (type === "reduce") {
      let valAdd = validation.values.items[i].quantity > 0 ? validation.values.items[i].quantity - 1 : validation.values.items[i].quantity;
      validation.values.items[i].quantity = valAdd;
      validation.values.items[i].total = Math.round(validation.values.items[i].amount * valAdd);
      handleTotal();
    }
  };

  const handleQuantityDetail = (e, i) => {
    let val = e.target.value;
    if (!isNaN(val)) {
      validation.values.items[i].quantity = val;
      validation.values.items[i].total = Math.round(validation.values.items[i].amount * val);
    } else {
      validation.values.items[i].quantity = 0;
      validation.values.items[i].total = Math.round(validation.values.items[i].amount * 0);
    }
    handleTotal();
  };

  const handleShipmentChange = (e) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.setFieldValue("shipment_amount", val);
    } else {
      validation.setFieldValue("shipment_amount", 0);
    }
  };

  const handleDiskonChange = (e) => {
    let val = parseFloat(e.target.value);
    if (!isNaN(val)) {
      validation.setFieldValue("disc_amount", val);
    } else {
      validation.setFieldValue("disc_amount", 0);
    }
  };

  const handleTaxChange = (e) => {
    let val = parseFloat(e.amount);
    if (!isNaN(val)) {
      validation.setFieldValue("tax_percentage", val);
      let sub_amount = 0;
      for (const item of validation.values.items) {
        sub_amount += parseFloat(item.quantity * item.amount);
      }
      let sub_total_net = sub_amount - validation.values.disc_amount;
      let tax_amount = (val / 100) * sub_total_net;
      let total_amount = sub_total_net + tax_amount + validation.values.shipment_amount;

      validation.setFieldValue("tax_amount", parseFloat(tax_amount));
      validation.setFieldValue("total_amount", parseFloat(total_amount));
      validation.setFieldValue("sub_amount", parseFloat(sub_amount));
    } else {
      validation.setFieldValue("tax_percentage", 0);
    }
    validation.setFieldValue("tax", e);
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePurchase(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    if (filterDate) {
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
      }
    }

    var status = statusPurchase.value ? statusPurchase.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      budget: searchBudget?.value ?? "",
      vendorId: searchVendor?.value ?? "",
      branchId: branchSelected?.value ?? "",
      typeId: 1,
    };
    dispatch(onGetPurchases(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setStatusPurchase([]);
    setSearchValue("");
    setSearchBudget("");
    setSearchVendor("");

    handleGetPurchase(companySelected?.value ?? "", branchSelected?.value ?? "");
  }

  document.title = "Permintaan Pembelian | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={purchaseList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePurchase} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Pengadaan Barang" pageTitle="Daftar Transaksi Pembelian" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPurchase") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                setSubmitType("save");
                validation.resetForm();
                toggle();
              }}
            >
              <i className="ri-bank-card-2-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={purchaseDoc} />
            {/* <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
                    </button>  */}
            {/* <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <p className="text-uppercase fw-medium text-muted mb-0">
                      PEMBELIAN
                    </p>
                  </div>
                  <div className="flex-shrink-0"></div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp
                        start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(rows || []).filter(f => f.original.statusId !== 6).reduce(
                          (a, v) =>
                            (a = a + parseFloat(v.original.total_amount || 0)),
                          0,
                        )}
                        duration={1}
                        className="counter-value"
                      />
                    </h4>
                    <span className="badge bg-info me-2">
                      {(rows || []).length}
                    </span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0">
                    <span className="avatar-title bg-light rounded fs-3">
                      <FeatherIcon
                        icon="file-text"
                        className="text-success icon-dual-success"
                      />
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <p className="text-uppercase fw-medium text-muted mb-0">
                      TERBAYAR
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <h5
                      className={
                        ((rows || []).filter(f => f.original.statusId !== 6).reduce(
                          (a, v) =>
                            (a = a + parseFloat(v.original.paid_amount || 0)),
                          0,
                        ) /
                          (rows || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) =>
                            (a =
                              a + parseFloat(v.original.total_amount || 0)),
                            0,
                          )) *
                          100 >
                          50
                          ? "fs-14 mb-0 text-success"
                          : "fs-14 mb-0 text-warning"
                      }
                    >
                      {" "}
                      <i
                        className={
                          ((rows || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) =>
                              (a = a + parseFloat(v.original.paid_amount || 0)),
                            0,
                          ) /
                            (rows || []).filter(f => f.statusId !== 6).reduce(
                              (a, v) =>
                              (a =
                                a + parseFloat(v.original.total_amount || 0)),
                              0,
                            )) *
                            100 >
                            50
                            ? "ri-arrow-right-up-line fs-13 me-2 align-middle"
                            : "ri-arrow-right-down-line fs-13 me-2 align-middle"
                        }
                      ></i>{" "}
                      {parseFloat(
                        ((rows || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                            (a = a + parseFloat(v.original.paid_amount || 0)),
                          0,
                        ) /
                          (rows || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) =>
                            (a =
                              a + parseFloat(v.original.total_amount || 0)),
                            0,
                          )) *
                        100,
                      ).toFixed(2)}{" "}
                      %
                    </h5>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp
                        start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(rows || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                            (a = a + parseFloat(v.original.paid_amount || 0)),
                          0,
                        )}
                        duration={1}
                        className="counter-value"
                      />
                    </h4>
                    <span className="badge bg-info me-2">
                      {
                        (rows || []).filter(f => f.statusId !== 6).filter(
                          (f) => parseFloat(f.original.paid_amount) > 0,
                        ).length
                      }
                    </span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0">
                    <span className="avatar-title bg-light rounded fs-3">
                      <FeatherIcon
                        icon="check-square"
                        className="text-success icon-dual-success"
                      />
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <p className="text-uppercase fw-medium text-muted mb-0">
                      MENUNGGU BAYAR
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <h5
                      className={
                        ((purchaseList || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                          (a =
                            a +
                            (parseFloat(v.total_amount || 0) -
                              parseFloat(v.paid_amount || 0))),
                          0,
                        ) /
                          (purchaseList || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) => (a = a + parseFloat(v.total_amount || 0)),
                            0,
                          )) *
                          100 >
                          50
                          ? "fs-14 mb-0 text-success"
                          : "fs-14 mb-0 text-warning"
                      }
                    >
                      {" "}
                      <i
                        className={
                          ((purchaseList || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) =>
                            (a =
                              a +
                              (parseFloat(v.total_amount || 0) -
                                parseFloat(v.paid_amount || 0))),
                            0,
                          ) /
                            (purchaseList || []).filter(f => f.statusId !== 6).reduce(
                              (a, v) =>
                                (a = a + parseFloat(v.total_amount || 0)),
                              0,
                            )) *
                            100 >
                            50
                            ? "ri-arrow-right-up-line fs-13 me-2 align-middle"
                            : "ri-arrow-right-down-line fs-13 me-2 align-middle"
                        }
                      ></i>{" "}
                      {parseFloat(
                        ((purchaseList || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                          (a =
                            a +
                            (parseFloat(v.total_amount || 0) -
                              parseFloat(v.paid_amount || 0))),
                          0,
                        ) /
                          (purchaseList || []).filter(f => f.statusId !== 6).reduce(
                            (a, v) => (a = a + parseFloat(v.total_amount || 0)),
                            0,
                          )) *
                        100,
                      ).toFixed(2)}{" "}
                      %
                    </h5>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp
                        start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        decimals=""
                        end={(purchaseList || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                          (a =
                            a +
                            (parseFloat(v.total_amount || 0) -
                              parseFloat(v.paid_amount || 0))),
                          0,
                        )}
                        duration={1}
                        className="counter-value"
                      />
                    </h4>
                    <span className="badge bg-info me-2">
                      {
                        (purchaseList || []).filter(
                          (f) =>
                            parseFloat(f.total_amount || 0) -
                            parseFloat(f.paid_amount || 0) >
                            0 && (f.statusId !== 6)
                        ).length
                      }
                    </span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0">
                    <span className="avatar-title bg-light rounded fs-3">
                      <FeatherIcon
                        icon="clock"
                        className="text-success icon-dual-success"
                      />
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} md={6}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <p className="text-uppercase fw-medium text-muted mb-0">
                      PENERIMAAN BARANG
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <h5
                      className={
                        ((purchaseList || []).filter(
                          (f) => parseFloat(f.accepted_amount || 0) > 0 && (f.statusId !== 6)
                        ).length /
                          (purchaseList || []).length) *
                          100 >
                          50
                          ? "fs-14 mb-0 text-success"
                          : "fs-14 mb-0 text-warning"
                      }
                    >
                      {" "}
                      <i
                        className={
                          ((purchaseList || []).filter(
                            (f) => parseFloat(f.accepted_amount || 0) > 0 && (f.statusId !== 6)
                          ).length /
                            (purchaseList || []).length) *
                            100 >
                            50
                            ? "ri-arrow-right-up-line fs-13 me-2 align-middle"
                            : "ri-arrow-right-down-line fs-13 me-2 align-middle"
                        }
                      ></i>{" "}
                      {parseFloat(
                        ((purchaseList || []).filter(
                          (f) => parseFloat(f.accepted_amount || 0) > 0 && (f.statusId !== 6)
                        ).length /
                          (purchaseList || []).length) *
                        100,
                      ).toFixed(2)}{" "}
                      %
                    </h5>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-1">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-2">
                      <CountUp
                        start={0}
                        separator="."
                        decimal=","
                        prefix=""
                        suffix="Ls"
                        decimals="2"
                        end={(purchaseList || []).filter(f => f.statusId !== 6).reduce(
                          (a, v) =>
                            (a = a + parseFloat(v.accepted_amount || 0)),
                          0,
                        )}
                        duration={1}
                        className="counter-value"
                      />
                    </h4>
                    <span className="badge bg-info me-2">
                      {
                        (purchaseList || []).filter(
                          (f) => parseFloat(f.accepted_amount || 0) > 0
                        ).length
                      }
                    </span>
                    <span className="text-muted">Transaksi</span>
                  </div>
                  <div className="avatar-xs flex-shrink-0">
                    <span className="avatar-title bg-light rounded fs-3">
                      <FeatherIcon
                        icon="package"
                        className="text-success icon-dual-success"
                      />
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-bank-card-2-line me-1 align-bottom fs-15"></i> SEMUA TRANSAKSI
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "CONFIRMED");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> CONFIRMED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("5", "RECEIVED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RECEIVED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "6" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("6", "COMPLETED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "7" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("7", "RETURNED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> RETURNED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "8" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("8", "CANCELED");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> CANCELED
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <Select
                            name="searchBudget"
                            isClearable={true}
                            value={searchBudget}
                            placeholder="Filter Anggaran"
                            onChange={(e) => {
                              setSearchBudget(e);
                            }}
                            options={civilBudgetTypeList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select

                            isClearable={true}
                            name="searchVendor"
                            value={searchVendor}
                            placeholder="Filter Supplier"
                            onChange={(e) => {
                              setSearchVendor(e);
                            }}
                            options={vendorList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}><i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}><i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="bg-soft-info">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          const detail = JSON.parse(row.values.Detail);
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                              {row.original.description && <tr className="bg-light">
                                <td colSpan={2}></td>
                                <td colSpan={8}>{row.original.description}</td>
                              </tr>}

                              {(detail || [])
                                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                .map((o, i) => {
                                  return (
                                    <tr key={i} className="bg-light">
                                      <td colSpan={2} className="p-2"></td>
                                      <td colSpan={4} className="text-start fs-12 p-2">
                                        {o?.purchase_cvl?.cvl_branch?.branch_code} {o?.purchase_cvl_budget?.type + ", " + o.cvl_account + " - " + o.name}
                                        <em className="ms-1">
                                          ({currencyFormat(o.quantity)} {o.purchase_detail_product?.product_uom?.name} * {currencyFormat(o.amount)})
                                        </em>
                                      </td>
                                      <td className="text-end fs-12 p-2 pe-3 text-muted">{currencyFormat(o.amount_total)}</td>
                                      <td colSpan={3} className="p-2"></td>
                                    </tr>
                                  );
                                })}
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modalBudget} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleBudget}>
                    KOREKSI DATA PEMBELIAN
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationBudget.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className="pe-2 ps-2 pt-3 border-top border-top-dashed position-relative">
                        {(clientLoading || companyLoading || productVarianLoading) && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div className="row">
                          <div className="col-lg-3 mb-3">
                            <Label className="form-label">
                              No. Invoice
                            </Label>
                            <Input value={validationBudget.values.transaction_reff} name="transaction_reff" className="form-control" placeholder="No Referensi" type="text" onChange={validationBudget.handleChange} onBlur={validationBudget.handleBlur} />
                          </div>
                          <div className="col-lg-3 mb-3">
                            <Label className="form-label">
                              Supplier
                            </Label>
                            <Select
                              name="vendor"
                              value={validationBudget.values.vendor}
                              placeholder="Pilih Supplier"
                              onChange={(e) => {
                                validationBudget.setFieldValue("vendor", e);
                              }}
                              options={vendorList}
                            ></Select>
                            {validationBudget.touched.vendor && validationBudget.errors.vendor && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationBudget.errors.vendor}
                              </p>
                            )}
                          </div>
                          <div className="col-lg-2 mb-3">
                            <Label className="form-label">
                              Department
                            </Label>
                            <div className="position-relative">
                              <Select
                                name="department"
                                value={validationBudget.values.department}
                                placeholder="Pilih Departemen"
                                onChange={(e) => {
                                  validationBudget.setFieldValue("department", e);
                                }}
                                options={departmentList}
                              ></Select>
                              <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                {departmentLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 mb-3">
                            <Label className="form-label">
                              Tgl Pembelian
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tgl Pembelian"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationBudget.setFieldValue("transactionat", dateStr);
                              }}
                              value={validationBudget.values.transactionat}
                            />
                            {validationBudget.touched.transactionat && validationBudget.errors.transactionat && (
                              <p className="invalid-feedback d-block" type="invalid">
                                {validationBudget.errors.transactionat}
                              </p>
                            )}
                          </div>
                          <div className="col-lg-2 mb-3">
                            <Label className="form-label">
                              Tgl Jatuh Tempo
                            </Label>
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Tgl Jatuh Tempo"
                              options={{
                                mode: "single",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                validationBudget.setFieldValue("dueat", dateStr);
                              }}
                              value={validationBudget.values.dueat}
                            />
                          </div>
                        </div>
                        <div className="table-responsive">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Material</th>
                                <th scope="col">Anggaran</th>
                                {userType === "admin" && (
                                  <>
                                    <th scope="col" className="text-start" style={{ width: "90px" }}>
                                      Harga
                                    </th>
                                    <th
                                      scope="col"
                                      className="text-center"
                                      style={{ width: "90px" }}
                                    >
                                      Jumlah
                                    </th>
                                    <th
                                      scope="col"
                                      className="text-center"
                                      style={{ width: "90px" }}
                                    >
                                      Terima
                                    </th>
                                    <th scope="col" className="text-end" style={{ width: "100px" }}>
                                      Total
                                    </th>
                                  </>
                                )}
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {validationBudget.values.items &&
                                validationBudget.values.items.map((o, i) => {
                                  let typeLabel;
                                  let type = o.type;
                                  switch (type) {
                                    case "BANGUNAN":
                                      typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
                                      break;
                                    case "INFRASTRUKTUR":
                                      typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
                                      break;
                                    case "UPAH":
                                      typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
                                      break;
                                    default:
                                      typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
                                      break;
                                  }
                                  return (
                                    <tr key={"purchaseDetailItem-" + i} className="product">
                                      <th scope="row" className="product-id">
                                        {i + 1}
                                      </th>
                                      <td className="text-start">
                                        <Select
                                          name="item"
                                          isDisabled={true}
                                          value={validationBudget.values && validationBudget.values.items ? validationBudget.values.items[i].item : {}}
                                          placeholder="Pilih Material"
                                          onChange={(e) => {
                                            validationBudget.values.items[i].item = e;
                                            validationBudget.values.items[i].sku = e.sku;
                                            validationBudget.values.items[i].barcode = e.barcode;
                                            validationBudget.values.items[i].itemId = e.value;
                                            validationBudget.values.items[i].uom = e.uom;
                                            validationBudget.values.items[i].brandId = e.brandId;
                                            validationBudget.values.items[i].amount = parseFloat(e.price);
                                            validationBudget.values.items[i].quantity = 1;
                                            if (validationBudget.values.items[i].cvl_account === "") {
                                              validationBudget.values.items[i].cvl_account = "";
                                              validationBudget.values.items[i].cvl_label = "";
                                              validationBudget.values.items[i].type = "";
                                              validationBudget.values.items[i].civilBudgetId = 0;
                                              validationBudget.values.items[i].civilBudgetDetailId = 0;
                                              validationBudget.values.items[i].civilAccountId = 0;
                                            }
                                            validationBudget.setFieldValue("items", validationBudget.values.items);
                                          }}
                                          options={materialList}
                                        ></Select>
                                        <em className="mb-0 fs-11 text-muted">
                                          {typeLabel} {o.cvl_account}
                                        </em>
                                      </td>
                                      <td>
                                        <Select
                                          name="civilBudgetDetail"
                                          value={validationBudget.values && validationBudget.values.items ? { label: validationBudget.values.items[i].type + " - " + validationBudget.values.items[i].cvl_account } : ""}
                                          placeholder="Pilih item Anggaran"
                                          onChange={(e) => {
                                            validationBudget.values.items[i].type = e?.type;
                                            validationBudget.values.items[i].cvl_account = e?.cvl_account;
                                            validationBudget.values.items[i].cvl_label = e?.label;
                                            validationBudget.values.items[i].civilBudgetId = e?.civilBudgetId;
                                            validationBudget.values.items[i].civilBudgetDetailId = e?.civilBudgetDetailId;
                                            validationBudget.values.items[i].civilAccountId = e?.civilAccountId;
                                            validationBudget.setFieldValue("items", validationBudget.values.items);
                                          }}
                                          options={civilBudgetList}
                                        ></Select>
                                      </td>

                                      {userType === "admin" && (
                                        <>
                                          <td><Input
                                            name="amount"
                                            placeholder="amount"
                                            type="number"
                                            className="form-control product-price"
                                            onFocus={(e) => e.target.select()}
                                            style={{ width: "140px" }}
                                            value={validationBudget.values && validationBudget.values.items ? validationBudget.values.items[i].amount : 0}
                                            onChange={(e) => {
                                              validationBudget.values.items[i].amount = e.target.value;
                                              validationBudget.setFieldValue("items", validationBudget.values.items);
                                            }}
                                            onBlur={validationBudget.handleBlur}
                                          />
                                          </td>
                                          <td className="text-center">
                                            <Input
                                              name="total"
                                              placeholder="Total"
                                              type="text"
                                              className="form-control product-line-price"
                                              style={{ width: "160px" }}
                                              value={
                                                validationBudget.values &&
                                                validationBudget.values.items &&
                                                validationBudget.values.items[i]
                                                  .quantity
                                              }
                                              onChange={(e) => {
                                                validationBudget.values.items[
                                                  i
                                                ].quantity = e.target.value;
                                                validationBudget.setFieldValue(
                                                  "items",
                                                  validationBudget.values.items,
                                                );
                                              }}
                                              onBlur={validationBudget.handleBlur}
                                            />
                                          </td>
                                          <td className="text-center">
                                            <Input
                                              name="total"
                                              placeholder="Total"
                                              type="text"
                                              className="form-control product-line-price"
                                              style={{ width: "160px" }}
                                              value={
                                                validationBudget.values &&
                                                validationBudget.values.items &&
                                                validationBudget.values.items[i]
                                                  .accepted
                                              }
                                              onChange={(e) => {
                                                validationBudget.values.items[
                                                  i
                                                ].accepted = e.target.value;
                                                validationBudget.setFieldValue(
                                                  "items",
                                                  validationBudget.values.items,
                                                );
                                              }}
                                              onBlur={validationBudget.handleBlur}
                                            />
                                          </td>
                                          <td className="text-end">
                                            <div>
                                              <Input name="total" placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "120px" }} disabled value={validationBudget.values && validationBudget.values.items && validationBudget.values.items[i].total} onChange={(e) => { }} onBlur={validationBudget.handleBlur} />
                                            </div>
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                  );
                                })}
                            </tbody>
                            <tbody>
                              <tr>
                                <td className="10">
                                  {validationBudget.touched.items && validationBudget.errors.items && (
                                    <small className="text-danger" type="invalid">
                                      {validationBudget.errors.items}
                                    </small>
                                  )}
                                </td>
                              </tr>
                              <tr id="newForm" style={{ display: "none" }}>
                                <td className="d-none" colSpan="5">
                                  <p>Tambah Form</p>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="mb-3">
                          <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={4} value={validationBudget.values.description ?? ""} onBlur={validationBudget.handleBlur} onChange={validationBudget.handleChange} />
                        </div>
                        <div className="mb-3 d-flex justify-content-between">
                          <Label htmlFor="education" className="form-label">
                            Dokumen Transaksi
                          </Label>
                          <button
                            type="button"
                            className="btn btn-sm btn-label btn-soft-success"
                            onClick={() => {
                              toggleMedia();
                            }}>
                            <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                          </button>
                        </div>
                        {purDocImg.map((f, i) => {
                          if (f.isDeleted) {
                            return null;
                          } else {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="d-flex justify-content-between mb-3 align-items-center">
                                  <div className="me-2">
                                    {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                      <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                    ) : (
                                      <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                        <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                      </Link>
                                    )}
                                  </div>
                                  <div className="text-truncate">{f.originalname}</div>
                                  <div>
                                    <Link
                                      to="#"
                                      className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                      onClick={(e) => {
                                        handleDeleteFile(f);
                                      }}
                                    >
                                      <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalBudget(false);
                            validationBudget.resetForm({});
                          }}>
                          TUTUP
                        </button>
                        <button type="submit" className={"btn btn-success"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            EDIT DATA PEMBELIAN &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modalStock} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleStock}>
                    KOREKSI STOCK PEMBELIAN
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationStock.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className="pe-2 ps-2 pt-3 border-top border-top-dashed position-relative">
                        {(clientLoading || companyLoading || productVarianLoading) && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div className="table-responsive">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Material</th>
                                <th scope="col" className="d-none">Anggaran</th>
                                <th scope="col" className="text-start d-none" style={{ width: "90px" }}>
                                  Harga
                                </th>
                                <th scope="col" className="text-center" style={{ width: "160px" }}>
                                  Jumlah
                                </th>
                                <th scope="col" className="text-center" style={{ width: "160px" }}>
                                  Terima
                                </th>
                                <th scope="col" className="text-end d-none" style={{ width: "100px" }}>
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {validationStock.values.items && validationStock.values.items.map((o, i) => {
                                let typeLabel;
                                let type = o.type;
                                switch (type) {
                                  case "BANGUNAN":
                                    typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
                                    break;
                                  case "INFRASTRUKTUR":
                                    typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
                                    break;
                                  case "UPAH":
                                    typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
                                    break;
                                  default:
                                    typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
                                    break;
                                }
                                return (
                                  <tr key={"purchaseDetailItem-" + i} className="product">
                                    <th scope="row" className="product-id">{i + 1}</th>
                                    <td className="text-start">
                                      <Select
                                        name="item"
                                        isDisabled={true}
                                        value={validationStock.values && validationStock.values.items ? validationStock.values.items[i].item : {}}
                                        placeholder="Pilih Material"
                                        onChange={(e) => {
                                          validationStock.values.items[i].item = e;
                                          validationStock.values.items[i].sku = e.sku;
                                          validationStock.values.items[i].barcode = e.barcode;
                                          validationStock.values.items[i].itemId = e.value;
                                          validationStock.values.items[i].uom = e.uom;
                                          validationStock.values.items[i].brandId = e.brandId;
                                          validationStock.values.items[i].amount = parseFloat(e.price);
                                          validationStock.values.items[i].quantity = 1;
                                          if (validationStock.values.items[i].cvl_account === "") {
                                            validationStock.values.items[i].cvl_account = "";
                                            validationStock.values.items[i].cvl_label = "";
                                            validationStock.values.items[i].type = "";
                                            validationStock.values.items[i].civilStockId = 0;
                                            validationStock.values.items[i].civilStockDetailId = 0;
                                            validationStock.values.items[i].civilAccountId = 0;
                                          }
                                          validationStock.setFieldValue("items", validationStock.values.items);
                                        }}
                                        options={materialList}
                                      ></Select>
                                      <em className="mb-0 fs-11 text-muted">
                                        {typeLabel} {o.cvl_account}
                                      </em>
                                    </td>
                                    <td className="d-none">
                                      <Select
                                        name="civilStockDetail"
                                        value={validationStock.values && validationStock.values.items ? { label: validationStock.values.items[i].type + " - " + validationStock.values.items[i].cvl_account } : ""}
                                        placeholder="Pilih item Anggaran"
                                        onChange={(e) => {
                                          validationStock.values.items[i].type = e?.type;
                                          validationStock.values.items[i].cvl_account = e?.cvl_account;
                                          validationStock.values.items[i].cvl_label = e?.label;
                                          validationStock.values.items[i].civilStockId = e?.civilStockId;
                                          validationStock.values.items[i].civilStockDetailId = e?.civilStockDetailId;
                                          validationStock.values.items[i].civilAccountId = e?.civilAccountId;
                                          validationStock.setFieldValue("items", validationStock.values.items);
                                        }}
                                        options={civilBudgetList}
                                      ></Select>
                                    </td>
                                    <td className="d-none">
                                      <Input
                                        name="amount"
                                        placeholder="amount"
                                        type="number"
                                        className="form-control product-price"
                                        onFocus={(e) => e.target.select()}
                                        style={{ width: "140px" }}
                                        value={validationStock.values && validationStock.values.items ? validationStock.values.items[i].amount : 0}
                                        onChange={(e) => {
                                          validationStock.values.items[i].amount = e.target.value;
                                          validationStock.setFieldValue("items", validationStock.values.items);
                                        }}
                                        onBlur={validationStock.handleBlur} />
                                    </td>
                                    <td className="text-center">
                                      <Input name="total" placeholder="Total" type="text" className="form-control product-line-price" style={{ width: "160px" }} value={validationStock.values && validationStock.values.items && validationStock.values.items[i].quantity} onChange={(e) => {
                                        validationStock.values.items[i].quantity = e.target.value;
                                        validationStock.setFieldValue("items", validationStock.values.items);
                                      }} onBlur={validationStock.handleBlur} />
                                    </td>
                                    <td className="text-center">
                                      <Input name="total" placeholder="Total" type="text" className="form-control product-line-price" style={{ width: "160px" }} value={validationStock.values && validationStock.values.items && validationStock.values.items[i].accepted} onChange={(e) => {
                                        validationStock.values.items[i].accepted = e.target.value;
                                        validationStock.setFieldValue("items", validationStock.values.items);
                                      }} onBlur={validationStock.handleBlur} />
                                    </td>
                                    <td className="text-end d-none">
                                      <div>
                                        <Input name="total" placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "120px" }} disabled value={validationStock.values && validationStock.values.items && validationStock.values.items[i].total} onChange={(e) => { }} onBlur={validationStock.handleBlur} />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr>
                                <td className="10">
                                  {validationStock.touched.items && validationStock.errors.items && (
                                    <small className="text-danger" type="invalid">
                                      {validationStock.errors.items}
                                    </small>
                                  )}
                                </td>
                              </tr>
                              <tr id="newForm" style={{ display: "none" }}>
                                <td className="d-none" colSpan="5">
                                  <p>Tambah Form</p>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalStock(false);
                            validationStock.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className={"btn btn-success"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            EDIT DATA PEMBELIAN &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modalSplit} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleSplit}>
                    SPLIT INVOICE
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationSplit.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className="pe-2 ps-2 pt-3 border-top border-top-dashed position-relative">
                        {(clientLoading || companyLoading || productVarianLoading) && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div className="mb-0">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "120px" }}>
                                  Invoice
                                </th>
                                <th scope="col">Material</th>
                                <th scope="col">Anggaran</th>
                                <th scope="col" className="text-start" style={{ width: "90px" }}>
                                  Jumlah
                                </th>
                                <th scope="col" className="text-center" style={{ width: "90px" }}>
                                  Terima
                                </th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {validationSplit.values.items_split &&
                                validationSplit.values.items_split.map((oo, ii) => {
                                  return (
                                    <Fragment key={ii}>
                                      <tr className="product">
                                        <th scope="row" className="product-id">
                                          No Invoice
                                        </th>
                                        <td>
                                          <Input
                                            name="invoice"
                                            placeholder="No invoice"
                                            type="text"
                                            className="form-control product-price"
                                            onFocus={(e) => e.target.select()}
                                            style={{ width: "100%" }}
                                            value={validationSplit.values && validationSplit.values.items_split && validationSplit.values.items_split[ii].transaction_reff}
                                            onChange={(e) => {
                                              validationSplit.values.items_split[ii].transaction_reff = e.target.value;
                                              validationSplit.setFieldValue("items_split", validationSplit.values.items_split);
                                            }}
                                            onBlur={validationSplit.handleBlur}
                                          />
                                        </td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      {validationSplit.values.items_split[ii].data.map((o, i) => {
                                        let typeLabel;
                                        let type = o.type;
                                        switch (type) {
                                          case "BANGUNAN":
                                            typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
                                            break;
                                          case "INFRASTRUKTUR":
                                            typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
                                            break;
                                          case "UPAH":
                                            typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
                                            break;
                                          default:
                                            typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
                                            break;
                                        }
                                        return (
                                          <tr key={"purchaseDetailItem-" + i} className="product">
                                            <th scope="row" className="product-id">
                                              {i + 1}
                                            </th>
                                            <td className="text-start">
                                              <Select
                                                name="item"
                                                isDisabled={true}
                                                value={validationSplit.values && validationSplit.values.items_split[ii].data ? validationSplit.values.items_split[ii].data[i].item : {}}
                                                placeholder="Pilih Material"
                                                onChange={(e) => {
                                                  validationSplit.values.items_split[ii].data[i].item = e;
                                                  validationSplit.values.items_split[ii].data[i].sku = e.sku;
                                                  validationSplit.values.items_split[ii].data[i].barcode = e.barcode;
                                                  validationSplit.values.items_split[ii].data[i].itemId = e.value;
                                                  validationSplit.values.items_split[ii].data[i].uom = e.uom;
                                                  validationSplit.values.items_split[ii].data[i].brandId = e.brandId;
                                                  validationSplit.values.items_split[ii].data[i].amount = parseFloat(e.price);
                                                  validationSplit.values.items_split[ii].data[i].quantity = 1;
                                                  if (validationSplit.values.items_split[ii].data[i].cvl_account === "") {
                                                    validationSplit.values.items_split[ii].data[i].cvl_account = "";
                                                    validationSplit.values.items_split[ii].data[i].cvl_label = "";
                                                    validationSplit.values.items_split[ii].data[i].type = "";
                                                    validationSplit.values.items_split[ii].data[i].civilSplitId = 0;
                                                    validationSplit.values.items_split[ii].data[i].civilSplitDetailId = 0;
                                                    validationSplit.values.items_split[ii].data[i].civilAccountId = 0;
                                                  }
                                                  validationSplit.setFieldValue("items_split", validationSplit.values.items_split);
                                                }}
                                                options={materialList}
                                              ></Select>
                                              <em className="mb-0 fs-11 text-muted">
                                                {typeLabel} {o.cvl_account}
                                              </em>
                                            </td>
                                            <td>
                                              <Select
                                                name="civilSplitDetail"
                                                value={validationSplit.values && validationSplit.values.items ? { label: validationSplit.values.items_split[ii].data[i].type + " - " + validationSplit.values.items_split[ii].data[i].cvl_account } : ""}
                                                placeholder="Pilih item Anggaran"
                                                onChange={(e) => {
                                                  validationSplit.values.items_split[ii].data[i].type = e?.type;
                                                  validationSplit.values.items_split[ii].data[i].cvl_account = e?.cvl_account;
                                                  validationSplit.values.items_split[ii].data[i].cvl_label = e?.label;
                                                  validationSplit.values.items_split[ii].data[i].civilSplitId = e?.civilSplitId;
                                                  validationSplit.values.items_split[ii].data[i].civilSplitDetailId = e?.civilSplitDetailId;
                                                  validationSplit.values.items_split[ii].data[i].civilAccountId = e?.civilAccountId;
                                                  validationSplit.setFieldValue("items_split", validationSplit.values.items_split);
                                                }}
                                                options={civilBudgetList}
                                              ></Select>
                                            </td>
                                            <td>
                                              <Input
                                                name="quantity"
                                                placeholder="Jumlah"
                                                type="number"
                                                className="form-control product-price"
                                                onFocus={(e) => e.target.select()}
                                                style={{ width: "140px" }}
                                                value={validationSplit.values && validationSplit.values.items_split[ii].data ? validationSplit.values.items_split[ii].data[i].quantity : 0}
                                                onChange={(e) => {
                                                  let arr = JSON.parse(JSON.stringify(validationSplit.values.items_split));
                                                  let obj = [];
                                                  let no = 0;
                                                  for (let a of arr) {
                                                    if (no === ii) {
                                                      let nod = 0;
                                                      for (let dd of a.data) {
                                                        if (nod === i) {
                                                          dd.quantity = e.target.value;
                                                        }
                                                        nod++;
                                                      }
                                                      obj.push(a);
                                                    } else {
                                                      obj.push(a);
                                                    }
                                                    no++;
                                                  }
                                                  validationSplit.setFieldValue("items_split", obj);
                                                }}
                                                onBlur={validationSplit.handleBlur}
                                              />
                                            </td>
                                            <td>
                                              <Input
                                                name="quantity"
                                                placeholder="Jumlah"
                                                type="number"
                                                className="form-control product-price"
                                                onFocus={(e) => e.target.select()}
                                                style={{ width: "140px" }}
                                                value={validationSplit.values && validationSplit.values.items_split[ii].data ? validationSplit.values.items_split[ii].data[i].accepted : 0}
                                                onChange={(e) => {
                                                  validationSplit.values.items_split[ii].data[i].accepted = e.target.value;
                                                  validationSplit.setFieldValue("items_split", validationSplit.values.items_split);
                                                }}
                                                onBlur={validationSplit.handleBlur}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </Fragment>
                                  );
                                })}
                            </tbody>
                            <tbody>
                              <tr>
                                <td className="10">
                                  {validationSplit.touched.items && validationSplit.errors.items && (
                                    <small className="text-danger" type="invalid">
                                      {validationSplit.errors.items}
                                    </small>
                                  )}
                                </td>
                              </tr>
                              <tr id="newForm" style={{ display: "none" }}>
                                <td className="d-none" colSpan="5">
                                  <p>Tambah Form</p>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="mb-3">
                          <Link
                            to="#"
                            className="btn btn-soft-success fw-medium"
                            id="add-item"
                            onClick={() => {
                              handlePurchaseSplitAdd();
                            }}>
                            <i className="ri-add-fill me-1 align-bottom"></i>SPLIT PEMBELIAN
                          </Link>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalSplit(false);
                            validationSplit.resetForm({});
                          }}>
                          TUTUP
                        </button>
                        <button type="submit" className={"btn btn-success"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            SPLIT INVOICE &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Permintaan Pembelian" : "Tambah Permintaan Pembelian"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className="border-bottom border-bottom-dashed p-2">
                        <Row>
                          <Col lg={6}>
                            <div className="profile-user mx-auto  mb-3">
                              <Input id="profile-img-file-input" type="file" className="profile-img-file-input" />
                              <Label for="profile-img-file-input" className="d-block">
                                <span className="overflow-hidden border border-dashed d-flex align-items-center justify-content-center rounded" style={{ height: "60px", width: "256px" }}>
                                  <img src={logoDark} className="card-logo card-logo-dark user-profile-image img-fluid" alt="logo dark" />
                                  <img src={logoLight} className="card-logo card-logo-light user-profile-image img-fluid" alt="logo light" />
                                </span>
                              </Label>
                            </div>
                            <div>
                              <div className="mb-3">
                                <Select
                                  name="branch"
                                  placeholder="Pilih Cabang / Proyek Penerima"
                                  value={validation.values.branch}
                                  onChange={(e) => {
                                    validation.setFieldValue("branch", e);
                                    validation.setFieldValue("civilBudgetId", "");

                                    validation.setFieldValue("tax_amount", 0);
                                    validation.setFieldValue("total_amount", 0);
                                    validation.setFieldValue("sub_amount", 0);
                                    validation.setFieldValue("items", []);

                                    setCivilBudgetList([]);
                                    setCivilBudgetTypeList([]);
                                    setBranchIdSelected(e.value);
                                    handleGetCivilBudget(validation.values.company.value, e.value);
                                  }}
                                  options={branchList}
                                ></Select>
                                {validation.touched.branch && validation.errors.branch && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.branch}
                                  </small>
                                )}
                              </div>
                              <Row>
                                <Col lg={6} sm={6} className="d-none mb-3">
                                  <Select
                                    name="shipmentMethod"
                                    placeholder="Metode Kirim"
                                    value={validation.values.shipmentMethod}
                                    onChange={(e) => {
                                      validation.setFieldValue("shipmentMethod", e);
                                    }}
                                    options={shipmentMethodList}
                                  ></Select>
                                  {validation.touched.shipmentMethod && validation.errors.shipmentMethod && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.shipmentMethod}
                                    </small>
                                  )}
                                </Col>
                                <Col lg={3} sm={3} className="d-none">
                                  <Select
                                    name="shipmentCarrier"
                                    placeholder="Kurir"
                                    value={validation.values.shipmentCarrier}
                                    onChange={(e) => {
                                      validation.setFieldValue("shipmentCarrier", e);
                                    }}
                                    options={shipmentCarrierList} ></Select>
                                  {validation.touched.shipmentCarrier && validation.errors.shipmentCarrier && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.shipmentCarrier}
                                    </small>
                                  )}
                                </Col>
                                <Col lg={7} sm={7}>
                                  <Select
                                    name="vendor"
                                    value={validation.values.vendor}
                                    placeholder="Pilih Supplier"
                                    onChange={(e) => {
                                      validation.setFieldValue("vendor", e);
                                    }}
                                    options={vendorList} ></Select>
                                  {vendorLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                  {validation.touched.vendor && validation.errors.vendor && (
                                    <p className="invalid-feedback d-block" type="invalid">
                                      {validation.errors.vendor}
                                    </p>
                                  )}
                                </Col>
                                <Col lg={5}>
                                  <div className="mb-3">
                                    <Flatpickr
                                      className="form-control"
                                      id="datepicker-publish-input"
                                      placeholder="Tgl Pembelian"
                                      options={{
                                        mode: "single",
                                        dateFormat: "Y/m/d",
                                      }}
                                      onChange={(selectedDates, dateStr) => {
                                        validation.setFieldValue("transactionat", dateStr);
                                      }}
                                      value={validation.values.transactionat}
                                    />
                                    {validation.touched.transactionat && validation.errors.transactionat && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.transactionat}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={7}>
                                  <div className="mb-3">
                                    <Select
                                      name="budget"
                                      value={validation.values.budget}
                                      placeholder="Pilih Cashflow"
                                      onChange={(e) => {
                                        validation.setFieldValue("budget", e);
                                      }}
                                      options={budgetList}
                                    ></Select>
                                    {validation.touched.budget && validation.errors.budget && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.budget}
                                      </small>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={5}>
                                  <div className="mb-3">
                                    <Input value={validation.values.transaction_reff} name="transaction_reff" id="transaction_reff" className="form-control" placeholder="No Referensi" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="d-none">
                                <Col lg={3} sm={3}>
                                  <Select
                                    name="block"
                                    placeholder="Blok"
                                    value={validation.values.block}
                                    onChange={(e) => {
                                      validation.setFieldValue("block", e);
                                      validation.setFieldValue("items", "");
                                      validation.setFieldValue("civilBudget", "");
                                      let arrUnit = [];
                                      if (productVarians.length) {
                                        productVarians.forEach((item) => {
                                          const varian = item.pvar_product ? item.pvar_product : "";
                                          const category = varian.product_category ? varian.product_category.name : "";
                                          const blck = varian.product_block ? varian.product_block.id : "";
                                          const branch = varian.branchId ? varian.branchId : "";
                                          if (blck === e.value && branch === branchIdSelected) {
                                            const blck_name = varian.product_block ? varian.product_block.name : "";
                                            const name = blck_name + "-" + varian.name;
                                            const id = item.id;
                                            const barcode = item.barcode;
                                            const sku = item.sku;
                                            const price = item.price;
                                            const brandId = item.brandId;
                                            const productId = item.productId;
                                            const priceBook = parseFloat(item.pvar_product.price_book);
                                            const land_excess = item.pvar_product ? item.pvar_product.land_excess : "";
                                            const land_price = item.pvar_product ? item.pvar_product.land_price : "";
                                            const price_handling = item.pvar_product ? item.pvar_product.price_handling : "";
                                            arrUnit.push({ label: name, name: name, barcode: barcode, sku: sku, value: id, price: price, brandId: brandId, productId: productId, priceBook: priceBook, land_excess: land_excess, land_price: land_price, price_handling: price_handling });
                                          }
                                        });
                                      }
                                      validation.setFieldValue("unit", arrUnit);
                                    }}
                                    options={blockList}
                                  ></Select>
                                  {validation.touched.block && validation.errors.block && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.block}
                                    </small>
                                  )}
                                </Col>
                                <Col lg={9} sm={9}>
                                  <div className="mb-3">
                                    <Select
                                      name="unit"
                                      isDisabled={validation.values.block.value === null || validation.values.block.value === "" ? true : false}
                                      value={validation.values.unit}
                                      placeholder="Blok Rumah Terkait"
                                      isMulti
                                      onChange={(opt, { option }) => {
                                        validation.setFieldValue("items", []);
                                        validation.setFieldValue("civilBudget", "");
                                        let newOpts = opt;
                                        if (option && option.value === "all") {
                                          let filteredOptions = clone(productList);
                                          filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                          newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                        }
                                        validation.setFieldValue("unit", newOpts);
                                      }}
                                      options={productList}
                                      noOptionsMessage={(e) => "Type User to get option"}
                                    ></Select>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="client"
                                  value={validation.values.client}
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    dispatch(setClientSelect(e));
                                    setCompanyList([]);
                                    setDepartmentList([]);
                                    setCivilBudgetList([]);
                                    setCivilBudgetTypeList([]);
                                    setVendorList([]);
                                    setBranchList([]);
                                    validation.setFieldValue("company", "");
                                    validation.setFieldValue("department", "");
                                    validation.setFieldValue("vendor", "");
                                    validation.setFieldValue("branch", "");
                                    validation.setFieldValue("client", e);
                                  }}
                                  options={clientList}
                                ></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}
                                >
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.client && validation.errors.client ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.client}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="company"
                                  value={validation.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setCompanySelect(e));
                                    setDepartmentList([]);
                                    setCivilBudgetList([]);
                                    setCivilBudgetTypeList([]);
                                    setVendorList([]);
                                    setBranchList([]);
                                    setProductList([]);
                                    setPaymentTermList([]);
                                    setPaymentMethodList([]);
                                    setShipmentCarrierList([]);
                                    setShipmentMethodList([]);
                                    setAccountingList([]);
                                    validation.resetForm();
                                    handleGetPurchase(e.value, branchSelected.vaue);
                                  }}
                                  options={companyList}
                                ></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}
                                >
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.company && validation.errors.company ? (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.company}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="department"
                                  value={validation.values.department}
                                  placeholder="Pilih Departemen"
                                  onChange={(e) => {
                                    validation.setFieldValue("department", e);
                                  }}
                                  options={departmentList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {departmentLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.department && validation.errors.department && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.department}
                                </p>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="pe-2 ps-2 pt-3 border-top border-top-dashed position-relative">
                        {(clientLoading || companyLoading || productVarianLoading) && (
                          <div className="position-absolute top-0">
                            <Spinner color="primary" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                            <Spinner color="success" type="grow" size={"sm"}>
                              Loading...
                            </Spinner>
                            &nbsp;
                          </div>
                        )}
                        <div className="mb-0 table-responsive">
                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col" className="text-start" style={{ width: "350px" }}>
                                  Material
                                </th>
                                <th scope="col" className="text-start" style={{ width: "120px" }}>
                                  Harga
                                </th>
                                <th scope="col" className="text-center" style={{ width: "90px" }}>
                                  Jumlah
                                </th>
                                <th scope="col" className="text-center" style={{ width: "90px" }}>
                                  Terima
                                </th>
                                <th scope="col" className="text-center" style={{ width: "90px" }}>
                                  Satuan
                                </th>
                                <th scope="col" className="text-end" style={{ width: "120px" }}>
                                  Total
                                </th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(validation.values.items || []).map((o, i) => {
                                let typeLabel;
                                let type = validation.values.items[i].type;
                                switch (type) {
                                  case "BANGUNAN":
                                    typeLabel = <span className="badge text-uppercase badge-soft-info">{type}</span>;
                                    break;
                                  case "INFRASTRUKTUR":
                                    typeLabel = <span className="badge text-uppercase badge-soft-success">{type}</span>;
                                    break;
                                  case "UPAH":
                                    typeLabel = <span className="badge text-uppercase badge-soft-warning">{type}</span>;
                                    break;
                                  default:
                                    typeLabel = <span className="badge text-uppercase badge-soft-primary">LAIN-LAIN</span>;
                                    break;
                                }
                                return (
                                  <tr key={"purchaseDetailItem-" + i} className="product">
                                    <th scope="row" className="product-id">
                                      {i + 1}
                                    </th>
                                    <td className="text-start">
                                      <Select
                                        name="item"
                                        isDisabled={validation.values.items[i].cvl_account === "" || validation.values.items[i].itemId === 0 ? false : true}
                                        value={validation.values && validation.values.items ? validation.values.items[i].item : {}}
                                        placeholder="Pilih Material"
                                        onChange={(e) => {
                                          validation.values.items[i].item = e;
                                          validation.values.items[i].sku = e.sku;
                                          validation.values.items[i].barcode = e.barcode;
                                          validation.values.items[i].itemId = e.value;
                                          validation.values.items[i].uom = e.uom;
                                          validation.values.items[i].brandId = e.brandId;
                                          validation.values.items[i].amount = parseFloat(e.price);
                                          validation.values.items[i].quantity = 1;
                                          if (validation.values.items[i].cvl_account === "") {
                                            validation.values.items[i].cvl_account = "";
                                            validation.values.items[i].cvl_label = "";
                                            validation.values.items[i].type = "";
                                            validation.values.items[i].civilBudgetId = 0;
                                            validation.values.items[i].civilBudgetDetailId = 0;
                                            validation.values.items[i].civilAccountId = 0;
                                          }
                                          handleTotal();
                                        }}
                                        options={materialList} ></Select>
                                      <em className="mb-0 fs-11 text-muted">
                                        {typeLabel} {validation.values.items[i].cvl_account}
                                      </em>
                                    </td>
                                    <td>
                                      <Input
                                        name="amount"
                                        placeholder="amount"
                                        type="number"
                                        className="form-control product-price"
                                        onFocus={(e) => e.target.select()}
                                        style={{ width: "140px" }}
                                        value={validation.values && validation.values.items ? validation.values.items[i].amount : 0}
                                        onChange={(e) => {
                                          handlePriceDetail(e, i);
                                        }}
                                        onBlur={validation.handleBlur}
                                      />
                                    </td>
                                    <td>
                                      <div className="input-step">
                                        <button
                                          disabled={validation.values.items[i].disable}
                                          type="button"
                                          className="minus"
                                          onClick={() => {
                                            handleBtnQtyDetail("reduce", i);
                                          }} > –
                                        </button>
                                        <Input
                                          name="quantity"
                                          disabled={validation.values.items[i].disable}
                                          placeholder="Qty"
                                          type="text"
                                          className="product-quantity border-0"
                                          style={{ width: "80px" }}
                                          onFocus={(e) => e.target.select()}
                                          value={validation.values && validation.values.items ? validation.values.items[i].quantity : 0}
                                          onChange={(e) => {
                                            handleQuantityDetail(e, i);
                                          }}
                                          onBlur={validation.handleBlur} />
                                        <button
                                          type="button"
                                          disabled={validation.values.items[i].disable}
                                          className="plus"
                                          onClick={() => {
                                            handleBtnQtyDetail("add", i);
                                          }}> +
                                        </button>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="mt-2">{validation.values.items[i].accepted}</div>
                                    </td>
                                    <td className="text-center">
                                      <div className="mt-2">{validation.values.items[i].uom}</div>
                                    </td>
                                    <td className="text-end">
                                      <div>
                                        <Input name="total" placeholder="Total" type="text" className="form-control product-line-price bg-light border-0" style={{ width: "180px" }} disabled value={validation.values && validation.values.items && validation.values.items[i].total} onChange={(e) => { }} onBlur={validation.handleBlur} />
                                      </div>
                                    </td>
                                    <td className="product-removal">
                                      {validation.values.items[i].accepted === 0 && (
                                        <Link
                                          to="#"
                                          className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                          onClick={() => {
                                            onClickDeleteDetailItem(i);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      )}
                                      {userType === "admin" && (
                                        <Link
                                          to="#"
                                          className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                          onClick={() => {
                                            onClickDeleteDetailItem(i);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            <tbody>
                              <tr>
                                <td className="10">
                                  {validation.touched.items && validation.errors.items && (
                                    <small className="text-danger" type="invalid">
                                      {validation.errors.items}
                                    </small>
                                  )}
                                </td>
                              </tr>
                              <tr id="newForm" style={{ display: "none" }}>
                                <td className="d-none" colSpan="5">
                                  <p>Tambah Form</p>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" style={{ verticalAlign: "middle", paddingBottom: "30px" }} className="">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      handlePurchaseDetailAdd();
                                    }}>
                                    <i className="ri-add-fill me-1 align-bottom"></i>Tambah Item Non RAB
                                  </Link>
                                </td>
                                <td style={{ verticalAlign: "middle", paddingBottom: "30px" }} className="fw-semibold text-end">
                                  Jika RAB Teknik
                                </td>
                                <td colSpan="5" style={{ verticalAlign: "middle", paddingBottom: "30px" }}>
                                  <Select
                                    name="civilBudgetDetail"
                                    placeholder="Pilih item Anggaran"
                                    onChange={(e) => {
                                      handlePurchaseDetailAddByBudget(e);
                                    }}
                                    options={civilBudgetList}
                                  ></Select>
                                </td>
                              </tr>
                              <tr className="border-top border-top-dashed mt-4">
                                <td colSpan="3">
                                  <div className="mb-3">
                                    <Select
                                      name="paymentMethod"
                                      value={validation.values.paymentMethod}
                                      placeholder="Pilih Jenis Transaksi"
                                      onChange={(e) => {
                                        validation.setFieldValue("paymentMethod", e);
                                      }}
                                      options={paymentMethodList}
                                    ></Select>
                                    {validation.touched.paymentMethod && validation.errors.paymentMethod && (
                                      <small className="text-danger" type="invalid">
                                        {validation.errors.paymentMethod}
                                      </small>
                                    )}
                                  </div>
                                  <Row>
                                    <div className="mb-3 col-lg-7">
                                      <Select
                                        name="paymentTerm"
                                        value={validation.values.paymentTerm}
                                        placeholder="Pilih Tempo Pembayaran"
                                        onChange={(e) => {
                                          validation.setFieldValue("paymentTerm", e);
                                          var new_date = moment(validation.values.transactionat, "YYYY/MM/DD").add(e.amount, "days");
                                          validation.setFieldValue("dueat", new_date.format("YYYY/MM/DD"));
                                        }}
                                        options={paymentTermList}
                                      ></Select>
                                    </div>
                                    <div className="mb-3 col-lg-5">
                                      <Flatpickr
                                        className="form-control"
                                        id="datepicker-publish-input"
                                        placeholder="Tgl Jatuh Tempo"
                                        options={{
                                          mode: "single",
                                          dateFormat: "Y/m/d",
                                        }}
                                        onChange={(selectedDates, dateStr) => {
                                          validation.setFieldValue("dueat", dateStr);
                                        }}
                                        value={validation.values.dueat}
                                      />
                                    </div>
                                  </Row>
                                  <div className="mb-3">
                                    <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={4} value={validation.values.description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} />
                                  </div>
                                  <div className="mb-3 d-flex justify-content-between">
                                    <Label htmlFor="education" className="form-label">
                                      Dokumen Transaksi
                                    </Label>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-label btn-soft-success"
                                      onClick={() => {
                                        toggleMedia();
                                      }}>
                                      <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                    </button>
                                  </div>
                                  {purDocImg.map((f, i) => {
                                    if (f.isDeleted) {
                                      return null;
                                    } else {
                                      return (
                                        <div key={i} className="border-bottom mb-3">
                                          <div className="d-flex justify-content-between mb-3 align-items-center">
                                            <div className="me-2">
                                              {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                                <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                              ) : (
                                                <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                                  <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                                </Link>
                                              )}
                                            </div>
                                            <div className="text-truncate">{f.originalname}</div>
                                            <div>
                                              <Link
                                                to="#"
                                                className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                                onClick={(e) => {
                                                  handleDeleteFile(f);
                                                }}>
                                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                </td>
                                <td></td>
                                <td colSpan="3" className="p-0">
                                  <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
                                    <tbody>
                                      <tr>
                                        <th scope="row">Sub Total</th>
                                        <td style={{ width: "150px" }}>
                                          <Input name="sub_amount" value={validation.values.sub_amount} type="text" className="form-control bg-light border-0" id="cart-subtotal" style={{ width: "180px" }} placeholder="0.00" disabled />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Diskon</th>
                                        <td>
                                          <Input name="disc_amount" id="disc_amount" className="form-control" placeholder="Diskon" type="number" value={validation.values.disc_amount} onChange={(e) => handleDiskonChange(e)} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Uang Muka</th>
                                        <td>
                                          <Input
                                            value={validation.values.down_payment}
                                            name="down_payment"
                                            id="down_payment"
                                            className="form-control"
                                            placeholder="Credit Amount"
                                            type="number"
                                            onFocus={(e) => e.target.select()}
                                            onChange={(e) => {
                                              let val = parseFloat(e.target.value);
                                              if (!isNaN(val)) {
                                                e.target.value = val.toString();
                                                validation.setFieldValue("down_payment", val);
                                              } else {
                                                e.target.value = 0;
                                                validation.setFieldValue("down_payment", 0);
                                              }
                                            }}
                                            onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Biaya Pengiriman</th>
                                        <td>
                                          <Input value={validation.values.shipment_amount} name="shipment_amount" id="shipment_amount" className="form-control" placeholder="Shipping Price" type="number" onChange={(e) => handleShipmentChange(e)} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                        </td>
                                      </tr>
                                      <tr style={{ position: "relative" }}>
                                        <th scope="row" style={{ position: "absolute", zIndex: 9999 }}>
                                          <Select name="tax" value={validation.values.tax} placeholder="Tax" onChange={(e) => handleTaxChange(e)} options={taxList}></Select>
                                        </th>
                                        <td>
                                          <Input name="tax_amount" type="text" className="form-control bg-light border-0" id="cart-tax" value={validation.values.tax_amount} style={{ width: "180px" }} placeholder="0" disabled />
                                        </td>
                                      </tr>
                                      <tr className="border-top border-top-dashed d-none">
                                        <th scope="row">Total Amount</th>
                                        <td>
                                          <Input name="total_amount" type="text" className="form-control bg-light border-0" id="cart-total" placeholder="0" value={validation.values.total_amount} style={{ width: "180px" }} disabled />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}
                        >
                          TUTUP
                        </button>
                        <button type="submit" className={submitType && (submitType === "save" || submitType === "process" || submitType === "received") ? "btn btn-success" : "btn btn-success d-none"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            {submitType === "process" ? "PROSES & TANDAI PEMBELIAN DITERIMA" : "SIMPAN DATA PEMBELIAN"} &nbsp;
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    PEMBAYARAN PEMBELIAN
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Jumlah
                          </Label>
                          <Input
                            name="amount"
                            id="amount-field"
                            className="form-control"
                            placeholder="Enter amount"
                            type="number"
                            onFocus={(e) => e.target.select()}
                            onChange={(e) => {
                              let paid_amount = !isNaN(parseFloat(info.paid_amount)) ? parseFloat(info.paid_amount) : 0;
                              let total_amount = !isNaN(parseFloat(info.total_amount)) ? parseFloat(info.total_amount) : 0;
                              let left_amount = total_amount - paid_amount;
                              if (!isNaN(parseFloat(e.target.value))) {
                                if (parseFloat(e.target.value) <= left_amount) validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                                else validationAccPayment.setFieldValue("amount", left_amount);
                              } else {
                                validationAccPayment.setFieldValue("amount", parseFloat(e.target.value));
                              }
                            }}
                            onBlur={validationAccPayment.handleBlur}
                            value={validationAccPayment.values.amount}
                            invalid={validationAccPayment.touched.amount && validationAccPayment.errors.amount ? true : false}
                          />
                          {validationAccPayment.touched.amount && validationAccPayment.errors.amount ? <FormFeedback type="invalid">{validationAccPayment.errors.amount}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label">
                            Tanggal Pembayaran
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                        </div>
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="account">
                            Akun Cash / Bank Pembayaran
                          </label>
                          <Select
                            name="account"
                            value={validationAccPayment.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.account}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalAccPayment(false);
                            validationAccPayment.resetForm();
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalHistory" isOpen={modalHistory} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleHistory}>
                    Riwayat Pembelian
                  </ModalHeader>
                  <ModalBody>
                    <div className="profile-timeline">
                      <div></div>
                      <div className="accordion accordion-flush" id="todayExample">
                        {info &&
                          info.purchase_history &&
                          info.purchase_history.map((item, i) => {
                            return (
                              <div key={i} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <button className="accordion-button p-2 shadow-none" type="button" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.purchase_history_createdby && item.purchase_history_createdby.employee_image && item.purchase_history_createdby.employee_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.purchase_history_createdby.employee_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item?.purchase_history_createdby?.name?.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.purchase_history_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">
                                          Memperbarui status pembelian menjadi <span className="fw-semibold text-info">{item?.purchase_history_status?.name}</span> dengan catatan:
                                        </p>
                                        <p className="fw-normal mb-1">{item.notes || "-"}</p>
                                        <small className="text-muted">
                                          <span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat, "YYYY/MM/DD HH:mm:ss").local().fromNow()}
                                        </small>
                                      </div>
                                    </div>
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModalHistory(false);
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalApprove" isOpen={modalApprove} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    ACTION CONFIRMATION
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationApprove.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="mt-2 text-center">
                        <lord-icon src="https://cdn.lordicon.com/puvaffet.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style={{ width: "100px", height: "100px" }}></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                          <p className="fs-16">{purchase && purchase.actionTitle}</p>
                        </div>
                        <div className="mt-3 col-lg-12">
                          <Input name="approval_note" id="approval_note-field" className="form-control" placeholder="Isi Keterangan (Jika Ada)" rows={4} type="textarea" onChange={validationApprove.handleChange} onBlur={validationApprove.handleBlur} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalApprove(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Submit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Invoice Detail
                  </ModalHeader>
                  {purchase !== undefined && purchase !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h4 className="text-uppercase fw-semibold">{purchase.client && purchase.client.label}</h4>
                                  <h5 className="mb-0 fs-15 fw-semibold">PROYEK {purchase.branch && purchase.branch.label}</h5>
                                </div>
                              </div>
                              <div>
                                <table className="mt-5" style={{ width: "350px" }}>
                                  <tbody>
                                    <tr className="border-bottom border-dashed">
                                      <td style={{ width: "100px" }}>Supplier</td>
                                      <td style={{ width: "20px" }}>:</td>
                                      <td>{purchase.vendor && purchase.vendor.contact ? purchase.vendor && purchase.vendor.contact + ", " + purchase.vendor.label : purchase.vendor && purchase.vendor.label}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">No PO</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{purchase.transaction_no || "PKG" + handleValidDate(purchase.transactionat, "YYYYMMDD") + purchase.id}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">No Referensi</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{purchase.transaction_reff}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(purchase.transactionat)}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(purchase.dueat)}</span>
                                </h5>
                              </Col>
                              <Col lg={2} xs={2}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Total</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="total-amount">{currencyFormat(purchase.total_amount)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col" className="text-start">
                                      Detail Produk
                                    </th>
                                    <th scope="col" className="text-start">
                                      Anggaran
                                    </th>
                                    <th scope="col">Harga</th>
                                    <th scope="col">Jumlah</th>
                                    <th scope="col">Satuan</th>
                                    <th scope="col">Terima</th>
                                    {/* <th scope="col">Rejected</th> */}
                                    <th scope="col" className="text-end">
                                      Total
                                    </th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {purchase.items &&
                                    purchase.items.length > 0 &&
                                    (purchase.items || [])
                                      .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }))
                                      .map((o, i) => {
                                        return (
                                          <tr key={i} id={i} className="product">
                                            <th scope="row" className="product-id">
                                              {i + 1}
                                            </th>
                                            <td className="text-start">{o.name}</td>
                                            <td className="text-start">
                                              {o?.type} - {o.cvl_account}
                                            </td>
                                            <td>Rp{currencyFormat(o.amount)}</td>
                                            <td>{currencyFormat(o.quantity)}</td>
                                            <td>{o.uom}</td>
                                            <td>{o.accepted}</td>
                                            {/* <td>{o.rejected}</td> */}
                                            <td className="text-end">Rp{currencyFormat(o.total)}</td>
                                          </tr>
                                        );
                                      })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="border-top border-top-dashed mt-2">
                              <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                                <tbody>
                                  <tr>
                                    <td>Sub Total</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.sub_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Diskon</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.disc_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Biaya Kirim</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.shipment_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Pajak {purchase.tax_percentage} %</td>
                                    <td className="text-end">Rp{currencyFormat(purchase.tax_amount)}</td>
                                  </tr>
                                  <tr className="border-top border-top-dashed fs-15">
                                    <th scope="row">Total</th>
                                    <th className="text-end">Rp{currencyFormat(purchase.total_amount)}</th>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {purchase.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4 row">
                              <div className="col-lg-6">
                                <p className="mb-0 text-center">Bogor, {handleValidDate(purchase.createdat)}</p>
                                <p className="mb-0 text-center">Pengajuan</p>
                                <p className="mb-5 pb-3 fw-semibold text-center">{purchase.purchase_createdby ? purchase.purchase_createdby.label : ""}</p>
                                <p style={{ height: "10px" }}></p>
                                <p className="mt-5 text-center">................................</p>
                              </div>
                              <div className="col-lg-6">
                                <p className="mb-0 text-center">{purchase.approvedat && handleValidDate(purchase.approvedat)}</p>
                                <p className="mb-0 text-center">Disetujui Oleh</p>
                                <p className="mb-5 pb-3 fw-semibold text-center">{purchase.purchase_approvedby ? purchase.purchase_approvedby.label : ""}</p>
                                <p style={{ height: "35px" }}></p>
                                <p className="mt-5 text-center">................................</p>
                              </div>
                            </div>
                          </CardBody>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              {(purchase.purchase_file || []).map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <Col lg={2} xs={2} key={i}>
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                        <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                      ) : (
                                        <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      )}
                                    </Col>
                                  );
                                }
                              })}
                            </Row>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetail();
                        }}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => {
                          handlePrint();
                        }}
                      >
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalDetailExpense" isOpen={modalDetailExpense} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetailExpense}>
                    Detail Print
                  </ModalHeader>
                  {info !== undefined && info !== null && (
                    <>
                      <PrintDocExpense innerRef={printRef} item={info} />
                    </>
                  )}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          toggleDetailExpense();
                        }}
                      >
                        Close
                      </button>
                      {<ButtonPrint innerRef={printRef} title={`print-${info?.nama ?? ""}`} />}
                    </div>
                  </div>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={purchase} />
      </Container>
    </div>
  );
};

export default Purchase;
